import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import "../assets/styling/range-date-picker.css";
import "react-calendar/dist/Calendar.css";
import PageTitle from "../components/common/PageTitle";
import "../assets/styling/Styles.css";
import { sideBarFields } from "../data/sideBarField";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./Styles.css";
import evapo from "../assets/images/evapo.png";
import api from "../api/api";
import { useTranslation } from "react-i18next";
import SensorEnvironmentStatus from "../components/common/SensorEnvironmentStatus";
import moment from "moment";
import useSensorData from "../utils/useSensorData";
import { getSensorDepths } from "../utils/sensorDepths";
import WaterChart from "../components/Simulation/WaterChart";
import EvapoChart from "../components/Simulation/EvapoChart";
import HourlyEvapoChart from "../components/Simulation/HourlyEvapoChart";
import SubSoil from "../components/blog/SubSoil";
import SoilMoistureLevels from "../components/common/SoilMoistureLevels";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "moment/locale/nb";
import momentTimezone from "moment-timezone";
import "../css/field.css";
import { Modal } from "react-bootstrap";
import swal from "sweetalert";
import LinearProgress from "@mui/material/LinearProgress";
import logo from "../assets/images/Logo smart farm1.jpg";
import { Switch, FormControlLabel, Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import SensorInstallModal from "../components/components-overview/SensorInstallModal";
import "../css/SensorInstallModal.css";
import { RadioTower, Sparkles, Hand, Droplet, Clock, ArrowUpRight } from "lucide-react";
import axios from "axios";
import "./FieldDetails.css";
import AgriculturalEventDrawer from "../components/calendar/AgriculturalEventDrawer";
import RainSourceBadge from "../components/calendar/RainSourceBadge";
import {
  AGRICULTURAL_EVENT_CATEGORIES,
  getAgriculturalCategory,
  getEventDurationLabel,
  getEventTitle,
  getEventColors,
  getRainAmountLabel,
  isWaterEvent,
} from "../utils/agriculturalEvents";
import {
  calendarRangeForAgriculturalEvent,
  formatAgriculturalDate,
} from "../utils/agriculturalDateTime";

import "moment/locale/fr";
import "moment/locale/ar";
import { calculationIssueLabels, calculationIssueText } from '../utils/calculationIssues';
const localizer = momentLocalizer(moment);
const calculationReasonLabels = {
  ...calculationIssueLabels,
  NO_ACTIVE_SEASON: "Aucune saison active n'est configurée.",
  MULTIPLE_ACTIVE_SEASONS: "Plusieurs saisons sont actives en même temps.",
  SEASON_START_MISSING_OR_INVALID: "La date de début de saison est absente ou invalide.",
  SEASON_START_IN_FUTURE: "La saison n'a pas encore commencé.",
  SEASON_ALREADY_ENDED: "La saison active est déjà terminée. Créez la nouvelle saison avec sa vraie date de début.",
  CROP_DURATION_INVALID: "La durée de la culture est invalide.",
  KC_DATA_MISSING: "La courbe Kc de la culture est manquante.",
  KC_DATA_INVALID: "La courbe Kc existe, mais son format est invalide.",
  KC_DATA_TOO_SHORT: "La courbe Kc est plus courte que la saison.",
  SOIL_RUMAX_MISSING: "La réserve utile maximale du sol est manquante.",
  FIELD_LOCATION_MISSING: "Les coordonnées du champ sont manquantes.",
  IRRIGATION_CONFIGURATION_MISSING: "La configuration d'irrigation est incomplète.",
  WEATHER_DATA_MISSING: "Les données météo nécessaires sont indisponibles.",
  WEATHER_DATA_MISSING_OR_SIMULATION_EMPTY: "Les données météo sont indisponibles ou la simulation est vide.",
  INTERNAL_CALCULATION_ERROR: "Une erreur interne a empêché le calcul.",
  RAINFALL_CHANGED_RECALCULATION_REQUIRED: "Données de pluie modifiées — recalcul nécessaire.",
};
// Set Monday as the first day of the week in moment
// moment.updateLocale("en", {
//   week: {
//     dow: 1, // Monday is the first day of the week
//   },
// });
const Field = () => {
  const [expandedIrrigation, setExpandedIrrigation] = useState({});
  const handleClick = async () => {
    try {
      // Get field id from localStorage
      const fieldId = localStorage.getItem("Field");

      if (!fieldId) {
        alert("No field ID found in local storage!");
        return;
      }

      // If API expects an array
      const fieldIdsArray = [fieldId];

      // Call the API
      const response = await api.post("/admin/fields-sensor-calcul", {
        fieldIds: fieldIdsArray,
      });

      alert("Calculation started successfully!");
    } catch (error) {
      console.error("Error calling API:", error);
      alert("Failed to start calculation.");
    }
  };

  const toggleIrrigation = (itemId) => {
    setExpandedIrrigation((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };
  const [showInstallModal, setShowInstallModal] = useState(false);
  const ENDPOINT = process.env.REACT_APP_SOCKET;
  let location = useLocation();
  let userUid = JSON.parse(localStorage.getItem("user") || "{}").id;
  const [cropState, setCS] = useState([]);
  const [sensors, setSensor] = useState([]);
  const Uid = useParams().id;
  const { t, i18n } = useTranslation();
  const lang = i18n.language || "en"; // 'en', 'fr', 'it', 'ar', etc.
  // 1) Met à jour moment quand la langue change
  useEffect(() => {
    let momentLocale = i18n.language;

    // Optional mapping if needed
    if (i18n.language === "en") momentLocale = "en-gb";

    moment.locale(momentLocale);
  }, [i18n.language]);

  const localizer = useMemo(() => momentLocalizer(moment), [i18n.language]);
  const calendarMessages = (t) => ({
    allDay: t("calendar_allDay"),
    previous: t("calendar_previous"),
    next: t("calendar_next"),
    today: t("calendar_today"),
    month: t("calendar_month"),
    week: t("calendar_week"),
    day: t("calendar_day"),
    date: t("calendar_date"),
    time: t("calendar_time"),
    event: t("calendar_event"),
    more: t("calendar_more"),
  });

  // 3) Messages (labels) traduits via i18next
  const messages = {
    allDay: t("calendar_allDay"),
    previous: t("calendar_previous"),
    next: t("calendar_next"),
    today: t("calendar_today"),
    month: t("calendar_month"),
    week: t("calendar_week"),
    day: t("calendar_day"),
    date: t("calendar_date"),
    time: t("calendar_time"),
    event: t("calendar_event"),
    showMore: (total) => `+${total} ${t("calendar_more")}`,
  };
  const { id } = useParams();
  // 4) rtl support minimal (pour arabe)
  const dir = lang === "ar" ? "rtl" : "ltr";
  // Add this near your other useState declarations (around line 140)
  const [hasCalculationData, setHasCalculationData] = useState(true);
  const [calculationLoadError, setCalculationLoadError] = useState(false);
  const [calculationIssues, setCalculationIssues] = useState([]);
  const [rainfallCalculationPending, setRainfallCalculationPending] = useState(false);
  const navigate = useNavigate();
  const [selectedField, setSelectedField] = useState([]);
  const [sensorCode, setSensorCode] = useState("");
  const [coord, setCoord] = useState({ lat: "37.05002", lon: "11.01442" });
  // const [events, setEvents] = useState([]);

  const [eventList, setEventList] = useState([]);
  const [editingAgriculturalEvent, setEditingAgriculturalEvent] = useState(null);
  const [dose, setDose] = useState("");
  const [time, setTime] = useState("");
  const [modifiedDose, setModifiedDose] = useState("");
  const [modifiedTime, setModifiedTime] = useState("");
  const [eventSource, setEventSource] = useState("");
  const [allCalcul, setAllCalcul] = useState([]);
  const [manualStartDate, setManualStartDate] = useState("");
  const [manualEndDate, setManualEndDate] = useState("");
  const [modifiedStart, setModifiedStart] = useState("");
  const [modifiedEnd, setModifiedEnd] = useState("");
  const [loading, setLoading] = useState(false);
  const [isToggled, setIsToggled] = useState(false);
  const [fields, setFields] = useState([]);

  const [weatherData, setWeatherData] = useState([]);
  const [resultCalcul, setResultCalcul] = useState([]);
  const [loadingCalcul, setLoadingCalcul] = useState(false);
  const [inputsCalcul, setInputsCalcul] = useState([]);
  const [isDuplicating, setIsDuplicating] = useState(false);

  const [activeChart, setActiveChart] = useState("evaporation");
  const [chartData, setChartData] = useState([]);
  // Add these states at the top of your component with other useState declarations
  const [viewMode, setViewMode] = useState("calendar"); // 'calendar' or 'list'
  const [searchQuery, setSearchQuery] = useState("");
  const [dateFilter, setDateFilter] = useState("all"); // 'all', 'upcoming', 'past', 'today', 'thisWeek', 'thisMonth'

  useEffect(() => {
    if (Uid) {
      localStorage.setItem("Field", Uid);
    }
  }, [Uid]);
  
const fetchActiveSeason = async () => {
  try {
    const res = await api.get(
      `${process.env.REACT_APP_BASE_URL}/field/${Uid}/crops?activeSeasonOnly=true`
    );
    setCS(res.data.crops || []);
  } catch (error) {
    console.error("Error fetching active season", error);
  }
};


  const handleCreateNew = () => {
    swal({
      title: t("create_new_field"),
      text: t("create_new_field_confirm_text"),
      icon: "info",
      buttons: [t("cancel"), t("confirm")],
    }).then((confirm) => {
      if (confirm) {
        // Rediriger vers la page de création
        window.location.href = "/add-field";
      }
    });
  };
  const handleDuplicate = async () => {
    if (isDuplicating) return;
    setIsDuplicating(true);

    try {
      // ✅ 1) Récupérer les données du champ pour vérifier crop_nature
      const fieldResponse = await api.get(
        `${process.env.REACT_APP_BASE_URL}/field/${Uid}/crops?activeSeasonOnly=true`
      );

      const crops = fieldResponse.data.crops;
      const hasCropNatureZero = crops.some(
        (crop) => crop.croptypes?.crop_nature === 0
      );

      // ✅ 2) Confirmation de l'utilisateur
      const confirm = await swal({
        title: t("duplicate_field_title"),
        text: t("duplicate_field_text"),
        icon: "info",
        buttons: [t("cancel"), t("confirm")],
      });

      if (!confirm) {
        setIsDuplicating(false);
        return;
      }

      let payload = {};

      // ✅ 3) Si crop_nature === 0, demander la date
      if (hasCropNatureZero) {
        const dateInput = await swal({
          title: t("enter_date_title"),
          content: {
            element: "input",
            attributes: {
              type: "date",
              required: true,
            },
          },
          buttons: [t("cancel"), t("confirm")],
        });

        if (!dateInput) {
          setIsDuplicating(false);
          return; // L'utilisateur a annulé
        }

        payload = { date: dateInput };
      }

      // ✅ 4) Appel API pour dupliquer le champ avec ou sans payload
      await api.post(`/field/duplicate/${Uid}`, payload);
      await fetchActiveSeason();
      await fetchDataCalcul();

      // ✅ 4) Afficher succès
      await swal(t("field_duplicated_success"), "success");
    } catch (error) {
      console.error("Erreur :", error);
      await swal("❌ Erreur", "Impossible de dupliquer le champ", "error");
    } finally {
      setIsDuplicating(false);
    }
  };

  // Add this helper function to filter by search and date
  const getFilteredAndSearchedEvents = () => {
    let filtered = getFilteredEvents();

    // Apply search filter
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter((event) => {
        const title = event.title?.toLowerCase() || "";
        const dose = event.dose?.toString() || "";
        const time = event.time?.toString() || "";
        return (
          title.includes(query) || dose.includes(query) || time.includes(query)
        );
      });
    }

    // Apply date filter
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    if (dateFilter === "today") {
      filtered = filtered.filter((event) => {
        const eventDate = new Date(event.start);
        return eventDate >= today && eventDate < tomorrow;
      });
    } else if (dateFilter === "upcoming") {
      filtered = filtered.filter((event) => new Date(event.start) >= now);
    } else if (dateFilter === "past") {
      filtered = filtered.filter((event) => new Date(event.start) < now);
    } else if (dateFilter === "thisWeek") {
      const weekStart = new Date(today);
      weekStart.setDate(today.getDate() - today.getDay());
      const weekEnd = new Date(weekStart);
      weekEnd.setDate(weekStart.getDate() + 7);
      filtered = filtered.filter((event) => {
        const eventDate = new Date(event.start);
        return eventDate >= weekStart && eventDate < weekEnd;
      });
    } else if (dateFilter === "thisMonth") {
      const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
      const monthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 1);
      filtered = filtered.filter((event) => {
        const eventDate = new Date(event.start);
        return eventDate >= monthStart && eventDate < monthEnd;
      });
    }

    return filtered.sort((a, b) => new Date(a.start) - new Date(b.start));
  };

  const chartConfig = {
    evaporation: {
      title: t("Evaporation_Analysis"),
      description: "Track evaporation rates and trends",
      icon: "fas fa-cloud-sun",
      component: <EvapoChart data={chartData} />,
    },
    water: {
      title: t("water_balance"),
      description: "Monitor water levels and quality",
      icon: "fas fa-tint",
      component: <WaterChart data={chartData} />,
    },
  };
  // 1. Add state for filtering events at the top of your component (around line 50)
  const [eventFilters, setEventFilters] = useState({
    rain: true,
    manual: true,
    refused: true,
    validated: true,
    waiting: true,
  });
  const [categoryFilters, setCategoryFilters] = useState(() =>
    Object.fromEntries(AGRICULTURAL_EVENT_CATEGORIES.map((category) => [category.code, true]))
  );
  const [showAgriculturalEventTypes, setShowAgriculturalEventTypes] = useState(false);

  // 2. Add function to toggle filters
  const toggleEventFilter = (filterType) => {
    setEventFilters((prev) => ({
      ...prev,
      [filterType]: !prev[filterType],
    }));
  };
  const toggleCategoryFilter = (categoryCode) => {
    setCategoryFilters((previous) => ({
      ...previous,
      [categoryCode]: !previous[categoryCode],
    }));
  };

  const isRainEvent = (event) => {
    const title = String(event?.title || "").trim().toLowerCase();
    return (
      event?.category_code === "rain" || event?.source === "rain" || title === "rain" || title === "rain event"
    );
  };

  // 3. Filter events based on active filters - add this function before the return statement
  const getFilteredEvents = () => {
    return eventList.filter((event) => {
      const categoryCode = getAgriculturalCategory(event.category_code, event).code;
      if (!categoryFilters[categoryCode]) return false;
      // Filter by source
      if (event.source === "rain" && !eventFilters.rain) return false;
      if (event.source === "manual" && !eventFilters.manual) return false;

      // Filter by status
      if (event.status === "refused" && !eventFilters.refused) return false;
      if (event.status === "validated" && !eventFilters.validated) return false;
      if (event.status === "waiting" && !eventFilters.waiting) return false;

      return true;
    });
  };

  const getEvents = async () => {
    try {
      const response = await api.get(`/field/get-event/${Uid}`);
      const eventData = response.data.events;
      if (response.data.issues?.length) {
        setHasCalculationData(false);
        setIrrigationAdvice(null);
        setCalculationIssues(response.data.issues.flatMap(issue=>issue.reasons).map(calculationIssueText));
      }

      // Normalize events: convert start/end to Date, dose/time to number
      const normalized = eventData.map((ev) => {
        const range = calendarRangeForAgriculturalEvent(ev);
        return {
          ...ev,
          raw_start: ev.start,
          raw_end: ev.end,
          id: ev.id || ev._id,
          start: range.start,
          end: range.end,
          allDay: range.isAllDay,
          time: ev.time ? Number(ev.time) : 0,
          dose: ev.dose ? Number(ev.dose) : 0,
        };
      });
      setEventList(normalized);
      return normalized; // Return for use in other functions
    } catch (error) {
      console.error("Error fetching events:", error);
      return [];
    }
  };
  const [eventStatus, setEventStatus] = useState("");
  const handleStatusUpdate = async (eventId, status) => {
    setShow(false);
    setCalendarLoading(true);

    try {
      const response = await api.post("/field/edit-event", {
        event_id: eventId,
        status,
      });

      if (response.data.type === "success") {
        swal({
          icon: "success",
          text: "Event status updated successfully.",
        });
        // update local event list
        setEventList(
          eventList.map((ev) => (ev.id === eventId ? { ...ev, status } : ev))
        );
        fetchDataCalcul();
        getEvents(); // optional refetch
      }
    } catch (error) {
      console.error(error);
      swal({
        icon: "error",
        text: "Error updating event status.",
      });
    } finally {
      setCalendarLoading(false);
    }
  };
  const currentChart = chartConfig[activeChart];

  let allDataSensor = useSensorData({ fieldId: id });

  const [recommendations, setRecmnd] = useState([]);
  const [currentSensorStatus, setCurrentSensorStatus] = useState(null);
  const [irrigationAdvice, setIrrigationAdvice] = useState(null);

  const loadCurrentSensorStatus = async () => {
    if (!Uid) return;
    try {
      const response = await api.get(`/field/${Uid}/current-sensor-status`);
      setCurrentSensorStatus(response.data?.state || null);
    } catch (error) {
      if (error.response?.status !== 404) {
        console.error("Unable to load current field sensor status:", error);
      }
    }
  };

  const loadIrrigationAdvice = async () => {
    if (!Uid) return;
    try {
      const response = await api.get(`/field/${Uid}/irrigation-advice`);
      setIrrigationAdvice(response.data?.advice || null);
    } catch (error) {
      if (error.response?.status !== 404) {
        console.error("Unable to load irrigation advice:", error);
      }
    }
  };

  useEffect(() => {
    loadCurrentSensorStatus();
    loadIrrigationAdvice();
    const handleRealtimeStatus = (event) => {
      const nextStatus = event.detail;
      if (nextStatus?.fieldUid === Uid) setCurrentSensorStatus(nextStatus);
    };
    const handleRealtimeAdvice = (event) => {
      const nextAdvice = event.detail;
      if (nextAdvice?.fieldUid === Uid) setIrrigationAdvice(nextAdvice);
    };
    window.addEventListener("smartfarm:field-status-updated", handleRealtimeStatus);
    window.addEventListener("smartfarm:irrigation-advice-updated", handleRealtimeAdvice);
    return () => {
      window.removeEventListener("smartfarm:field-status-updated", handleRealtimeStatus);
      window.removeEventListener("smartfarm:irrigation-advice-updated", handleRealtimeAdvice);
    };
  }, [Uid]);

  const latestSensorObservedAt = Array.isArray(allDataSensor)
    ? allDataSensor[0]?.timestamp_arduino || allDataSensor[0]?.time
    : null;

  useEffect(() => {
    if (latestSensorObservedAt) {
      loadCurrentSensorStatus();
      loadIrrigationAdvice();
    }
  }, [Uid, latestSensorObservedAt]);

  useEffect(() => {
    if (resultCalcul.length > 0) loadIrrigationAdvice();
  }, [Uid, resultCalcul]);
  // Update chart_sensor_active when toggle changes
  const handleToggleSensorChart = async (newValue) => {
    try {
      const response = await api.post("/field/update-sensor-chart-status", {
        fieldId: selectedField.id,
        chart_sensor_active: newValue ? 1 : 0,
      });

      if (response.data.type === "success") {
        // chart_sensor_active updated
      } else {
        console.error("❌ Failed to update chart_sensor_active");
        // Revert toggle if update failed
        setIsToggled(!newValue);
        swal({
          icon: "error",
          text: t("failed_to_update_sensor_status"),
        });
      }
    } catch (error) {
      console.error("Error updating chart_sensor_active:", error);
      // Revert toggle if request failed
      setIsToggled(!newValue);
      swal({
        icon: "error",
        text: t("error_updating_sensor_status"),
      });
    }
  };
  const [loadingsoil, setLoadingsoil] = React.useState(true);
  useEffect(() => {
    setLoadingsoil(true);

    if (Array.isArray(sensors) && sensors.length === 0) {
      setLoadingsoil(false);
      return;
    }
    if (Array.isArray(sensors) && sensors.length > 0) {
      if (Array.isArray(allDataSensor) && allDataSensor.length > 0) {
        // We have both sensors and data - stop loading
        setLoadingsoil(false);
      }
      // If we have sensors but no data, keep loading (don't set to false)
    }
  }, [sensors, allDataSensor]);

  const [et0, setET0] = useState(2);
  // 1. Add this function to calculate season end date and check if season has ended
  const checkSeasonStatus = () => {
    if (cropState.length === 0) return { seasonEnded: false };

    const crop = cropState[0]; // Get the first crop
    const growingDate = new Date(crop.growingDate);
    const days = parseInt(crop.days || 365);

    // Calculate season end date
    const seasonEndDate = new Date(growingDate);
    seasonEndDate.setDate(seasonEndDate.getDate() + days);

    const currentDate = new Date();
    const seasonEnded = currentDate > seasonEndDate;
    return {
      seasonEnded,
      seasonStartDate: growingDate,
      seasonEndDate,
      remainingDays: seasonEnded
        ? 0
        : Math.ceil((seasonEndDate - currentDate) / (1000 * 60 * 60 * 24)),
    };
  };

  // 2. Add state for season status (add this near your other useState declarations)
  const [seasonStatus, setSeasonStatus] = useState({ seasonEnded: false });

  // 3. Add useEffect to check season status when cropState changes
  useEffect(() => {
    const status = checkSeasonStatus();
    setSeasonStatus(status);
  }, [cropState]);

  useEffect(() => {
    getEvents();
  }, [Uid]);
  useEffect(() => {
    setInterval(() => {
      return allDataSensor;
    }, 60000);
  }, []);
  const [depth, setDepth] = useState(getSensorDepths());
  const fetchData = async () => {
    setLoading(true);

    try {
      const response = await api.get(
        `${process.env.REACT_APP_BASE_URL}/field/${Uid}/crops?activeSeasonOnly=true`
      );
      let newData = response.data;
      setSelectedField(newData.field);
      setCoord({
        lat: parseFloat(newData.field.Latitude).toFixed(3),
        lon: parseFloat(newData.field.Longitude).toFixed(3),
      });

      const dataSensor = await api.get(
        `${process.env.REACT_APP_BASE_URL}/field/${Uid}/sensors`
      );
      const result = dataSensor;
      setSensor(result.data.sensors);
      let sensor = result.data.sensors;

      if (sensor.length > 0) {
        setSensorCode(sensor[0].code);
        const newDepth = getSensorDepths(sensor[0]);
        setDepth(newDepth);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  let field_uid = localStorage.getItem("Field");
  let user_uid = JSON.parse(localStorage.getItem("user") || "{}").id;
  const [formData, setFormData] = useState({
    user_uid: user_uid,
    field_uid: field_uid,
    status: "interested",
  });
  useEffect(() => {
    fetchData();
    fetchActiveSeason();
  }, [Uid]);

  useEffect(() => {
    const weather = async () => {
      await api
        .post("/weather/get-data", {
          type: "day",
          lat: coord.lat,
          lon: coord.lon,
        })

        .then((response) => {
          var today = {};
          let weatherData = response.data.data;
          today.city = weatherData.name;
          today.wind = weatherData.wind.speed;
          if (typeof weatherData.rain !== "undefined") {
            today.rain = weatherData.rain["1h"];
          }
          today.windDirection = weatherData.wind.deg;
          today.date = new Date(weatherData.dt * 1000);
          today.temp = weatherData.main.temp.toFixed(1);
          today.main = weatherData.weather[0].main;
          today.description = weatherData.weather[0].description;
          today.icon = weatherData.weather[0].icon;
          today.humidity = weatherData.main.humidity;
          today.pressure = weatherData.main.pressure;
          today.visibility = weatherData.visibility;

          setWeatherData(today);
        })
        .catch(function (error) {
          console.error(error);
        });
    };
    weather();
  }, [coord.lat, coord.lon]);

  const getRecommendation = async () => {
    let field_id = selectedField.id;
    if (field_id !== undefined) {
      await api
        .get(`/recommendation/recommendations/${field_id}`)
        .then((response) => {
          let recommendations = response.data.recommendations;
          setRecmnd(recommendations);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  useEffect(() => {
    getRecommendation();
  }, [selectedField]);
  useEffect(() => {
    localStorage.setItem("code", sensorCode);
  }, [sensorCode]);

  // Modify the fetchDataCalcul function (around line 590)
  const fetchDataCalcul = async () => {
    setLoadingCalcul(true);
    try {
      const url = `/calcul/field-calcul/${Uid}`;
      const response1 = await api.get(url);

      // Check if we have calculation data
      const hasData = response1.data.calcul && response1.data.calcul.length > 0;
      setHasCalculationData(hasData);
      if (!hasData) {setIrrigationAdvice(null);setResultCalcul([]);setAllCalcul([]);}
      setCalculationLoadError(false);
      const responseField = response1.data.field || {};
      setRainfallCalculationPending(responseField.calculation_error === "RAINFALL_CHANGED_RECALCULATION_REQUIRED");
      const issueCodes = responseField.calculation_reasons?.length
        ? responseField.calculation_reasons
        : String(responseField.calculation_error || "").split(",").filter(Boolean);
      setCalculationIssues(issueCodes.map((reason) => calculationReasonLabels[reason] || calculationIssueText(reason)));

      setResultCalcul(response1.data.calcul);
      setInputsCalcul(response1.data.inputs);
      if (response1.data.field && response1.data.field.chart_sensor_active !== undefined) {
        setIsToggled(response1.data.field.chart_sensor_active === 1);
      }
      setAllCalcul(response1.data.calcul || []);
      setLoadingCalcul(false);
    } catch (err) {
      console.error(err);
      setHasCalculationData(false);
      setCalculationLoadError(true);
      setIrrigationAdvice(null);
      setResultCalcul([]);
      setAllCalcul([]);
      setCalculationIssues([]);
      setLoadingCalcul(false);
    }
  };
  useEffect(() => {
    fetchDataCalcul();
  }, [Uid]);

  const [mappingMv1, setMappingMv1] = useState("");
  const [mappingMv2, setMappingMv2] = useState("");
  const [mappingMv3, setMappingMv3] = useState("");

  const mappingMv = async (date, idSensor, vals) => {
    setMappingMv1(allDataSensor[0].mv1);
    setMappingMv2(allDataSensor[0].mv2);
    setMappingMv3(allDataSensor[0].mv3);

  };

  useEffect(() => {
    allDataSensor.map(async (sensors) => {
      await mappingMv(sensors.time, sensors.sensor_id, [
        sensors.mv1,
        sensors.mv2,
        sensors.mv3,
      ]);
    });
  }, [allDataSensor]);

  useEffect(() => {
    let data = [];
    let ET0 = 0;
    let RuMax = "";
    let todayDate = new Date();
    let today = todayDate.toISOString().slice(0, 10);
    resultCalcul.map((result) => {
      if (result) {
        data.push({
          bilan: result.bilan,
          ETC: result.Etc,
          dates: result.date,
          RUmax: result.RUmax,
          RUmin: result.RUMin,
          ruInitial: result.ruActuelle,
          RUabs: 10,
        });
      }
      if (result.date.slice(0, 10) === today) {
        ET0 = result.ET0;
      }
    });

    setET0(ET0);
    setChartData(data);
  }, [resultCalcul]);
  const filteredSensors = allDataSensor.filter((sensor) => {
    if (sensorCode !== "") {
      return sensor.code.toLowerCase().includes(sensorCode.toLowerCase());
    }

    // return sensor
  });

const toHoursAndMinutes = (totalMinutes) => {
  const totalSeconds = Math.round(totalMinutes * 60);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours === 0 && minutes === 0) {
    return `${seconds} secondes`;
  }
  if (hours === 0) {
    return `${minutes}min ${seconds > 0 ? `${seconds} secondes` : ""}`.trim();
  }
  return `${hours}h ${minutes}min`;
};
  // Marker Position Based on Bilan Hydrique
  const [selectedIrrigationIndex, setSelectedIrrigationIndex] = useState(0);
  const [progressData, setProgressData] = useState([]);

  useEffect(() => {
    const calculateProgressData = () => {
      const newData = [];

      resultCalcul.forEach((data) => {
        if (data) {
          const tomorrow = moment(data.date.slice(0, 10))
            .add(1, "days")
            .locale("En")
            .format("MMM DD");
          const today = moment(data.date.slice(0, 10))
            .locale("En")
            .format("MMM DD");
          const yesterday = moment(data.date.slice(0, 10))
            .subtract(1, "days")
            .locale("En")
            .format("MMM DD");

          const progress = data.bilan || 0; // Update this with the actual field from your data
          // const markerPosition = Math.round((progress / 100) * 80); // Calculate the position of the marker based on progress
          const markerPosition = Math.round(
            ((progress - data.RUMin) / (data.RUmax - data.RUMin)) * 100
          );

          newData.push({
            tomorrow,
            today,
            yesterday,
            progress,
            markerPosition,
          });
        }
      });

      setProgressData(newData);
    };

    calculateProgressData();
  }, [resultCalcul]);

  const handleSelectSlot = (slotInfo) => {
    const clickedDate = moment(slotInfo.start).startOf("day").toDate();
    setSelectedSlot({
      start: clickedDate,
      end: moment(clickedDate).add(1, "days").toDate(),
    });
    setManualStartDate(moment(clickedDate).format("YYYY-MM-DD"));
    setManualEndDate(moment(clickedDate).format("YYYY-MM-DD")); // Optional
    setEditingAgriculturalEvent(null);
    setShowForNew(true); // open the modal
  };
  const recomBasedOnDate = () => {
    const todayDate = new Date();

    const todayCalcul = resultCalcul.find((calcul) => {
      const date = new Date(calcul.date);
      return date.toDateString() === todayDate.toDateString();
    });

    const irrigationNbr = Number(todayCalcul?.irrigationNbr) || 0;
    const fallbackAdvice = todayCalcul
      ? {
          decision: irrigationNbr > 0 ? "irrigate" : "do_not_irrigate",
          confidence: "medium",
          headlineKey: irrigationNbr > 0
            ? "irrigation_advice_headline_irrigate_validate"
            : "irrigation_advice_headline_no_irrigation_planned",
          explanationKey: irrigationNbr > 0
            ? "irrigation_advice_explanation_irrigate_unconfirmed"
            : "irrigation_advice_explanation_no_irrigation_unconfirmed",
          reasonKeys: [irrigationNbr > 0
            ? "irrigation_advice_reason_calendar_irrigation"
            : "irrigation_advice_reason_calendar_no_irrigation"],
          calendar: {
            status: irrigationNbr > 0 ? "irrigation_planned" : "no_irrigation",
            dose: Number(todayCalcul.irrigation) || 0,
            duration: Number(todayCalcul.irrigationTime) || 0,
            rain: Number(todayCalcul.weather?.precipitation ?? todayCalcul.rain) || 0,
          },
          sensor: currentSensorStatus
            ? {
                status: currentSensorStatus.status,
                qualityStatus: currentSensorStatus.qualityStatus,
                observedAt: currentSensorStatus.observedAt,
              }
            : null,
          calculatedAt: new Date().toISOString(),
        }
      : {
          decision: "insufficient",
          confidence: "low",
          headlineKey: "irrigation_advice_headline_insufficient",
          explanationKey: "irrigation_advice_explanation_insufficient",
          reasonKeys: ["irrigation_advice_reason_no_calendar"],
          calendar: { status: "unavailable", dose: null, duration: null, rain: null },
          sensor: null,
          calculatedAt: new Date().toISOString(),
        };
    const advice = hasCalculationData ? (irrigationAdvice || fallbackAdvice) : { ...fallbackAdvice, decision:'insufficient', confidence:'low', headlineKey:'irrigation_advice_headline_insufficient', explanationKey:'irrigation_advice_explanation_insufficient', reasonKeys:['irrigation_advice_reason_no_calendar'], calendar:{status:'unavailable',dose:null,duration:null,rain:null} };
    const liveStatusDate = advice.sensor?.observedAt
      ? new Intl.DateTimeFormat(i18n.language || "fr", {
          timeZone: "Africa/Tunis",
          dateStyle: "short",
          timeStyle: "short",
        }).format(new Date(advice.sensor.observedAt))
      : null;
    const adviceDate = advice.calculatedAt
      ? new Intl.DateTimeFormat(i18n.language || "fr", {
          timeZone: "Africa/Tunis",
          dateStyle: "short",
          timeStyle: "short",
        }).format(new Date(advice.calculatedAt))
      : todayDate.toLocaleDateString();
    const actionTone = {
      irrigate: "irrigate",
      do_not_irrigate: "no-irrigate",
      verify: "verify",
      insufficient: "insufficient",
    }[advice.decision] || "insufficient";
    const sourceAgreementKey = {
      high: "irrigation_advice_sources_agree",
      medium: "irrigation_advice_sensor_to_confirm",
      low: "irrigation_advice_data_insufficient",
      conflict: "irrigation_advice_sources_disagree",
    }[advice.confidence] || "irrigation_advice_to_verify";
    const sensorStatusLabel = advice.sensor?.qualityStatus === "valid"
      ? advice.sensor.status === "Critical"
        ? t("irrigation_advice_sensor_dry")
        : advice.sensor.status === "Full"
          ? t("irrigation_advice_sensor_wet")
          : t("irrigation_advice_sensor_stable")
      : advice.sensor?.qualityStatus === "stale"
        ? t("irrigation_advice_sensor_stale")
        : advice.sensor
          ? t("irrigation_advice_sensor_measure_to_confirm")
          : t("irrigation_advice_sensor_unavailable");
    const actionIcon = {
      irrigate: "fa-droplet",
      "no-irrigate": "fa-circle-check",
      verify: "fa-magnifying-glass",
      insufficient: "fa-circle-exclamation",
    }[actionTone];

    return (
      <Col lg="4" md="12" sm="12" className="field-overview-column field-status-column">
        {cropState.length === 0 ? (
          <Card
            className="field-overview-card field-status-card"
            style={{
              height: "414.6px",
              color: "var(--sf-night-muted, #888)",
            }}
          >
            <Card.Header
              style={{
                background: "linear-gradient(135deg, var(--sf-night-primary, var(--sf-primary-turquoise, #26a6b7)) 0%, var(--sf-night-primary, var(--sf-medium-turquoise, #e8f7f9)) 100%)",
                color: "white",
                borderRadius: "12px 12px 0 0",
                padding: "15px 20px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              {t("field_status")}
            </Card.Header>
            <Card.Body className="field-status-empty">
              <span><i className="fas fa-seedling" aria-hidden="true" /></span>
              <strong>{t("field_no_crop_title", { defaultValue: "Aucune culture active" })}</strong>
              <p>{t("No crop data available")}</p>
            </Card.Body>
          </Card>
        ) : (
          cropState.map((item, indx) => {
            const hasIrrigation =
              item.irrigations && item.irrigations.length > 0;

            return (
              <Card
                key={indx}
                className="field-overview-card field-status-card"
                style={{
                  height:
                    sensors.length === 0 || allDataSensor.length === 0
                      ? "414.6px"
                      : "555.8px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Card.Header
                  style={{
                    background:
                      "linear-gradient(135deg, var(--sf-night-primary, var(--sf-primary-turquoise, #26a6b7)) 0%, var(--sf-night-primary, var(--sf-medium-turquoise, #e8f7f9)) 100%)",
                    color: "white",
                    borderRadius: "12px 12px 0 0",
                    padding: "15px 20px",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  {t("field_status")}
                </Card.Header>

                <Card.Body
                  className="py-2 hide-scrollbar"
                  style={{
                    overflowY: "auto",
                    overflowX: "hidden",
                    flex: 1,
                  }}
                >
                  {/* 🌱 Irrigation Info */}
                  <Row className="border-bottom bg-light py-3">
                    {hasIrrigation ? (
                      item.irrigations.length === 1 ? (
                        // Show single irrigation info directly
                        <Col>
                          {t("Irrigation_system_type")}:{" "}
                          <span style={{ textTransform: "capitalize" }}>
                            {t(item.irrigations[0].type)}
                          </span>
                          <br />
                          {t("FlowRate")} : {item.irrigations[0].flowrate} (l/h)
                        </Col>
                      ) : (
                        <>
                          {/* Selected Irrigation Info */}
                          <Col>
                            {t("Irrigation_system_type")}:{" "}
                            <span style={{ textTransform: "capitalize" }}>
                              {t(
                                item.irrigations[
                                  selectedIrrigationIndex
                                ].type.trim()
                              )}
                            </span>
                            <br />
                            {t("FlowRate")} :{" "}
                            {item.irrigations[selectedIrrigationIndex].flowrate}{" "}
                            (l/h)
                          </Col>

                          {/* Circular Buttons */}
                          <Col
                            xs="12"
                            className="mb-2 d-flex justify-content-center gap-2"
                          >
                            {item.irrigations.map((_, index) => (
                              <button
                                key={index}
                                onClick={() =>
                                  setSelectedIrrigationIndex(index)
                                }
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  borderRadius: "50%",
                                  border: "none",
                                  backgroundColor:
                                    index === selectedIrrigationIndex
                                      ? "var(--sf-night-info-fill, #007bff)"
                                      : "var(--sf-night-surface, #fff)",
                                  color:
                                    index === selectedIrrigationIndex
                                      ? "#fff"
                                      : "var(--sf-night-text, #000)",
                                  cursor: "pointer",
                                  outline: "none",
                                }}
                              >
                                {index + 1}
                              </button>
                            ))}
                          </Col>
                        </>
                      )
                    ) : (
                      <Col className="text-center text-muted">---</Col>
                    )}
                  </Row>

                  {/* 🔄 Recommandation Section OR Spinner */}
                  <Row className="mt-3">
                    {loadingCalcul ? (
                      <Col
                        className="d-flex flex-column justify-content-center align-items-center"
                        style={{ height: 200 }}
                      >
                        <img
                          src={logo}
                          alt="Loading"
                          className="loading-logo mb-2"
                          style={{ height: 50, objectFit: "cover" }}
                        />
                        <p
                          style={{
                            margin: 0,
                            fontWeight: "300",
                            color: "var(--sf-night-text-secondary, #555)",
                            fontSize: "14px",
                          }}
                        >
                          {t("Loading recommendation...")}
                        </p>
                      </Col>
                    ) : (
                      <>
                        <Col lg="12" sm="12" md="12">
                          <p
                            style={{
                              margin: 2,
                              fontWeight: "bold",
                              textAlign: "center",
                            }}
                          >
                            {t("recommandation")}
                          </p>
                        </Col>

                        <Card className={`m-2 field-action-card field-action-card--${actionTone}`}>
                          <Card.Header className="border-bottom d-flex flex-wrap justify-content-between align-items-center">
                            <div
                              className={`field-action-signal field-action-signal--${actionTone}`}
                              role="status"
                              aria-live="polite"
                            >
                              <span className="field-action-signal__icon" aria-hidden="true">
                                <i className={`fas ${actionIcon}`} />
                              </span>
                              <span className="field-action-signal__content">
                                <small>{t("irrigation_advice_decision")}</small>
                                <strong>{t(advice.headlineKey)}</strong>
                                <time className="field-action-decision-date" dateTime={advice.calculatedAt || undefined}>
                                  <i className="fas fa-clock" aria-hidden="true" /> {t("irrigation_advice_updated_at", { date: adviceDate })}
                                </time>
                              </span>
                            </div>
                            <div className={`field-source-status field-source-status--${advice.confidence}`}>
                              <i className="fas fa-code-compare" aria-hidden="true" />
                              {t(sourceAgreementKey)}
                            </div>
                          </Card.Header>

                          <Card.Body className="field-advice-body">
                            <p className="field-advice-explanation">{t(advice.explanationKey)}</p>

                            <div className="field-evidence-grid" aria-label={t("irrigation_advice_sources_label")}>
                              <div className="field-evidence field-evidence--calendar">
                                <span><i className="fas fa-calendar-check" aria-hidden="true" /> {t("irrigation_advice_calendar")}</span>
                                <strong>{advice.calendar?.status === "irrigation_planned" ? t("irrigation_advice_calendar_irrigation") : advice.calendar?.status === "no_irrigation" ? t("irrigation_advice_calendar_no_irrigation") : t("irrigation_advice_unavailable")}</strong>
                                <small>{t("irrigation_advice_water_balance_decision")}</small>
                              </div>
                              <div className={`field-evidence field-evidence--sensor field-evidence--${advice.sensor?.qualityStatus || "unavailable"}`}>
                                <span><i className="fas fa-tower-broadcast" aria-hidden="true" /> {t("irrigation_advice_sensor")}</span>
                                <strong>{sensorStatusLabel}</strong>
                                <small>{liveStatusDate ? t("irrigation_advice_last_measure", { date: liveStatusDate }) : t("irrigation_advice_no_recent_measure")}</small>
                              </div>
                              <div className="field-evidence field-evidence--weather">
                                <span><i className="fas fa-cloud-rain" aria-hidden="true" /> {t("irrigation_advice_weather")}</span>
                                <strong>{advice.calendar?.rain == null ? t("irrigation_advice_forecast_unavailable") : Number(advice.calendar.rain) > 0 ? t("irrigation_advice_rain_forecast", { value: Number(advice.calendar.rain).toFixed(1) }) : t("irrigation_advice_no_rain_forecast")}</strong>
                                <small>{t("irrigation_advice_weather_in_balance")}</small>
                              </div>
                            </div>

                            {Array.isArray(advice.reasonKeys) && advice.reasonKeys.length > 0 && (
                              <ul className="field-advice-reasons">
                                {advice.reasonKeys.slice(0, 2).map((reasonKey, index) => (
                                  <li key={`${reasonKey}-${index}`}>{t(reasonKey)}</li>
                                ))}
                              </ul>
                            )}

                            <div className="field-advice-footer">
                              <Button
                                type="button"
                                className="field-advice-calendar-button"
                                onClick={() => document.querySelector(".rbc-calendar")?.scrollIntoView({ behavior: "smooth", block: "start" })}
                              >
                                <i className="fas fa-calendar-days me-1" aria-hidden="true" />
                                {t("irrigation_advice_view_calendar")}
                              </Button>
                            </div>
                            <small className="field-advice-safety">
                              {t("irrigation_advice_sensor_safety")}
                            </small>
                          </Card.Body>
                        </Card>
                      </>
                    )}
                  </Row>
                </Card.Body>
              </Card>
            );
          })
        )}
      </Col>
    );
  };
  const eventStyleGetter = (event) => {
    return {
      style: {
        ...getEventColors(event),
        borderRadius: "7px",
        padding: "4px 8px",
        margin: "2px 0",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        fontSize: "12px",
        lineHeight: "1.2em",
        overflow: "hidden",
        textOverflow: "ellipsis",
        borderInlineStart: "3px solid var(--sf-night-border, rgba(255,255,255,0.65))",
        boxShadow: "0 2px 5px var(--sf-night-shadow, rgba(26,56,47,0.2))",
        cursor: "pointer",
      },
    };
  };

  const [show, setShow] = useState(false);
  const [showForNew, setShowForNew] = useState(false);

  const [selectedEvent, setSelectedEvent] = useState(null);

  // Calendar Events

  // const handleEventUpdate = (eventToUpdate, updatedEvent) => {
  //   setEvents(
  //     events.map((event) =>
  //       event.event_id === eventToUpdate.event_id ? updatedEvent : event
  //     )
  //   );
  // };
  const [calendarLoading, setCalendarLoading] = useState(false);

  const handleEventSelect = (event) => {
    if ((event.category_code && event.source === "manual") || isRainEvent(event)) {
      setEditingAgriculturalEvent(event);
      setManualStartDate(
        formatAgriculturalDate(event.start_at || event.raw_start || event.start),
      );
      setManualEndDate(
        formatAgriculturalDate(event.end_at || event.raw_end || event.end),
      );
      setShowForNew(true);
      return;
    }
    setSelectedEvent(event);
    setModifiedStart(event.start.toISOString().slice(0, 10));
    setModifiedEnd(event.end.toISOString().slice(0, 10));
    setModifiedDose(event.dose ? parseFloat(event.dose).toFixed(2) : 0);
    setModifiedTime(event.time ? parseFloat(event.time).toFixed(2) : 0);
    setEventStatus(event.status || ""); // load existing status

    // Use source directly from DB
    setEventSource(event.source); // "manual" or "recommendation"

    setShow(true);
  };

  const handleCloseModal = () => {
    setShow(false);
  };
  const handleNewIrrigCloseModal = () => {
    setShowForNew(false);
    setEditingAgriculturalEvent(null);
  };

  const [selectedSlot, setSelectedSlot] = useState(null);
  const [eventType, setEventType] = useState(""); // 'irrigation' or 'rain'
  const [rainfallAmount, setRainfallAmount] = useState();
  const [rainDuration, setRainDuration] = useState();

  const handleSaveEvent = async () => {
    setShowForNew(false);
    setCalendarLoading(true);

    if (manualEndDate < manualStartDate) {
      setCalendarLoading(false);
      swal({ icon: "error", text: "End date must be after start date." });
      return;
    }

    const newEvent = {
      title: "Irrigation Event",
      start: selectedSlot.start,
      end: selectedSlot.end,
      dose: dose,
      time: time,
      source: "manual",
      status: "validated",
    };

    let data = {
      field_uid: Uid,
      title: "manual Event",
      start: moment(manualStartDate)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss"),
      end: moment(manualEndDate).endOf("day").format("YYYY-MM-DD HH:mm:ss"),
      time: time,
      dose: dose,
      source: "manual",
      status: "validated",
    };

    try {
      const response = await api.post("/field/add-event", data);

      if (response.data.type === "success") {
        setEventList([...eventList, newEvent]);
        getEvents();
        fetchDataCalcul();
        swal({ icon: "success" });

        // ✅ Reset form fields
        setManualStartDate(null);
        setManualEndDate(null);
        setTime("");
        setDose("");
      }
    } catch (error) {
      console.error(error);
      swal({ icon: "error", text: "Error saving the event." });
    } finally {
      setCalendarLoading(false);
    }
  };

  const handleSaveRain = async () => {
    setShowForNew(false);
    setCalendarLoading(true);

    if (manualEndDate < manualStartDate) {
      setCalendarLoading(false);
      swal({ icon: "error", text: "End date must be after start date." });
      return;
    }

    const newEvent = {
      title: "Rain Event",
      start: selectedSlot.start,
      end: selectedSlot.end,
      dose: rainfallAmount,
      time: rainDuration,
      source: "manual",
      status: "validated",
    };

    let data = {
      field_uid: Uid,
      title: "Rain Event",
      start: moment(manualStartDate)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss"),
      end: moment(manualEndDate).endOf("day").format("YYYY-MM-DD HH:mm:ss"),
      time: rainDuration,
      dose: rainfallAmount,
      source: "manual",
      status: "validated",
    };

    try {
      const response = await api.post("/field/add-event", data);

      if (response.data.type === "success") {
        setEventList([...eventList, newEvent]);
        getEvents();
        fetchDataCalcul();
        swal({ icon: "success", text: "Rain event saved successfully!" });

        // ✅ Reset form fields
        setManualStartDate(null);
        setManualEndDate(null);
        setRainDuration("");
        setRainfallAmount("");
      }
    } catch (error) {
      console.error(error);
      swal({ icon: "error", text: "Error saving the rain event." });
    } finally {
      setCalendarLoading(false);
    }
  };
useEffect(() => {
  if (sensors.length > 0) {
    const selectedSensor = sensors.find(sensor => sensor.code === sensorCode);
    if (selectedSensor) {
      setDepth(getSensorDepths(selectedSensor));
    }
  }
}, [sensorCode, sensors]);

  // Updated handleModalUpdate - Ready to paste
  const handleModalUpdate = async (updatedData) => {
    setShow(false);
    setCalendarLoading(true);

    try {
      const payload = { event_id: selectedEvent.id, ...updatedData };
      const response = await api.post("/field/edit-event", payload);

      if (response.data.type === "success") {
        swal({ icon: "success", text: "Event updated successfully." });
        await getEvents();
        fetchDataCalcul();
      } else {
        swal({ icon: "error", text: "Failed to update event." });
      }
    } catch (error) {
      console.error(error);
      swal({ icon: "error", text: "Error updating the event." });
    } finally {
      setCalendarLoading(false);
    }
  };
  // Updated handleEventDelete - Ready to paste
  const handleEventDelete = async (eventId) => {
    setShow(false);
    setCalendarLoading(true);

    try {
      const payload = { event_id: eventId };
      const response = await api.post("/field/delete-event", payload);

      if (response.data.type === "success") {
        swal({ icon: "success", text: "Event deleted successfully." });
        await getEvents();
        fetchDataCalcul();
      } else {
        swal({ icon: "error", text: "Failed to delete event." });
      }
    } catch (error) {
      console.error(error);
      swal({ icon: "error", text: t("event_delete_error") });
    } finally {
      setCalendarLoading(false);
    }
  };

  // Replace your single handleSaveEvent with two separate functions:

  return (
    <>
      {loading ? (
        <Container fluid className="field-detail-page field-detail-skeleton" aria-busy="true" aria-live="polite">
          <span className="visually-hidden">{t("loading")}</span>
          <div className="field-skeleton-hero">
            <div>
              <span className="field-skeleton-line is-eyebrow" />
              <span className="field-skeleton-line is-title" />
            </div>
            <span className="field-skeleton-button" />
          </div>
          <div className="field-skeleton-meta">
            {[1, 2, 3, 4].map((item) => (
              <div key={item} className="field-skeleton-meta-card">
                <span className="field-skeleton-icon" />
                <div>
                  <span className="field-skeleton-line is-label" />
                  <span className="field-skeleton-line is-value" />
                </div>
              </div>
            ))}
          </div>
          <div className="field-skeleton-content">
            <div className="field-skeleton-panel is-main">
              <span className="field-skeleton-line is-heading" />
              <span className="field-skeleton-block" />
            </div>
            <div className="field-skeleton-panel">
              <span className="field-skeleton-line is-heading" />
              <span className="field-skeleton-block" />
            </div>
          </div>
        </Container>
      ) : (
        <Container fluid className="field-detail-page">
          {/* First Row of Posts */}
          <Row noGutters className="field-detail-hero-row justify-content-center">
            {cropState.length > 0 ? (
              cropState.map((item, indx) => (
                <Card
                  key={item.id || indx}
                  style={{
                    maxWidth: "1180px",
                  }}
                  className="field-detail-hero-card mb-4"
                >
                  <Card.Header
                    className="field-detail-hero-header d-flex justify-content-between align-items-center"
                  >
                    {/* Title */}
                    <span>{t("Field_Info")}</span>

                    {/* Button on the right */}
                    <Button
                      variant="light"
                      size="sm"
                      onClick={() => navigate(`/field-history-season/${Uid}`)}
                      className="field-detail-history-button d-flex align-items-center gap-2"
                    >
                      <i className="fas fa-history"></i>
                      {t("view_season_history")}
                    </Button>
                  </Card.Header>

                  <Card.Body className="field-detail-meta">
                    <div className="field-detail-meta-item">
                      {t("field")} : {selectedField.name}
                    </div>
                    <div className="field-detail-meta-item">
                      {t("crop_type")} : {item.croptypes?.crop || "---"}
                    </div>
                    <div className="field-detail-meta-item">
                      {t("crop_variety")} :{" "}
                      {item.varieties?.crop_variety?.trim()
                        ? item.varieties.crop_variety
                        : "---"}
                    </div>
                    <div className="field-detail-meta-item">
                      {t("planting_date")} :{" "}
                      {item.plantingDate
                        ? new Date(item.plantingDate).toLocaleDateString()
                        : "---"}
                    </div>
                  </Card.Body>
                </Card>
              ))
            ) : (
              <Card className="field-detail-hero-card mb-4">
                <Card.Header
                  className="field-detail-hero-header d-flex justify-content-between align-items-center"
                >
                  {/* Title */}
                  <span>{t("Field_Info")}</span>

                  {/* Button on the right */}
                  <Button
                    variant="light"
                    size="sm"
                    onClick={() => navigate(`/field-history-season/${Uid}`)}
                    className="field-detail-history-button d-flex align-items-center gap-2"
                  >
                    <i className="fas fa-history"></i>
                    {t("view_season_history")}
                  </Button>
                </Card.Header>

                <Card.Body className="field-detail-meta">
                  <div className="field-detail-meta-item">
                    {t("field")} : {selectedField?.name || "---"}
                  </div>
                  <div className="field-detail-meta-item">{t("crop_type")} : ---</div>
                  <div className="field-detail-meta-item">{t("crop_variety")} : ---</div>
                  <div className="field-detail-meta-item">{t("planting_date")} : ---</div>
                </Card.Body>
              </Card>
            )}
          </Row>
          {/* second Row of Posts */}
          <Row className="field-detail-content mb-4">
            <Col lg="12" md="12" sm="12">
              <Row className="justify-content-center gap-4">
                <Col lg="4" md="12" sm="12" className="field-overview-column field-sensors-column">
                  {/* active sensors  */}
                  {sensors.length > 0 && allDataSensor.length > 0 ? (
                    <Card
                      fluid
                      className="field-sensors-card field-overview-card"
                      style={{ minHeight: "555.8px", minWidth: "100%" }}
                    >
                      <>
                        <Card.Header
                          style={{
                            background:
                              "linear-gradient(135deg, var(--sf-night-primary, var(--sf-primary-turquoise, #26a6b7)) 0%, var(--sf-night-primary, var(--sf-medium-turquoise, #e8f7f9)) 100%)",
                            color: "white",
                            borderRadius: "12px 12px 0 0",
                            padding: "15px 20px",
                            fontSize: "16px",
                            fontWeight: "600",
                          }}
                          className="field-sensors-header border-bottom"
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              height: "100%",
                              alignItems: "center",
                            }}
                          >
                            {t("active_sensors")}

                 <Form.Select
  className="field-sensors-select"
  style={{ width: "50%" }}
  value={sensorCode}
  onChange={(evt) => {
    setSensorCode(evt.target.value);
  }}
>
  {sensors.map((sensor, i) => (
    <option key={i} value={sensor.code}>
      {sensor.code}
    </option>
  ))}
</Form.Select>

                          </div>
                        </Card.Header>

                        <Card.Body className="pt-0">
                          <div style={{ paddingTop: 10 }}>
                            {filteredSensors &&
                              filteredSensors.map((data, indx) => {
                                let prss = data.pressure === null || data.pressure === undefined
                                  ? null
                                  : data.pressure / 1000;
                                return (
                                  <React.Fragment key={indx}>
                                    <SensorEnvironmentStatus environment={data.environment} />
                                    <div
                                      className="field-sensors-metrics"
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-evenly",
                                        paddingTop: 10,
                                        fontSize: 13,
                                      }}
                                    >
                                    <div
                                      className="field-sensor-metric field-sensor-temperature"
                                      style={{
                                        textAlign: "center",
                                        color: "var(--sf-night-text, black)",
                                      }}
                                    >
                                      <i
                                        className="fas fa-thermometer-three-quarters"
                                        style={{ fontSize: "20px" }}
                                      ></i>
                                      <p style={{ margin: 0, color: "var(--sf-night-text, black)" }}>
                                        {t("Temp.")} (°C)
                                      </p>
                                      <p style={{ margin: 0, color: "var(--sf-night-text, black)" }}>
                                        {data.temperature ?? "—"}
                                      </p>
                                    </div>
                                    <div className="field-sensor-metric field-sensor-humidity" style={{ textAlign: "center" }}>
                                      <i
                                        className="fas fa-tint"
                                        style={{
                                          fontSize: "20px",
                                          color: "var(--sf-night-text, black)",
                                        }}
                                      />
                                      <p style={{ margin: 0, color: "var(--sf-night-text, black)" }}>
                                        {t("Humidity")} (%){" "}
                                      </p>
                                      <p style={{ margin: 0, color: "var(--sf-night-text, black)" }}>
                                        {data.humidity ?? "—"}
                                      </p>
                                    </div>
                                    <div className="field-sensor-metric field-sensor-pressure" style={{ textAlign: "center" }}>
                                      <i
                                        className="fas fa-tachometer-alt"
                                        style={{
                                          fontSize: "20px",
                                          color: "var(--sf-night-text, black)",
                                        }}
                                      />
                                      <p style={{ margin: 0, color: "var(--sf-night-text, black)" }}>
                                        {t("Pression")} (kPa)
                                      </p>
                                      <p style={{ margin: 0, color: "var(--sf-night-text, black)" }}>
                                        {prss === null ? "—" : parseFloat(prss).toFixed(3)}
                                      </p>
                                    </div>
                                    <div className="field-sensor-metric field-sensor-altitude" style={{ textAlign: "center" }}>
                                      <i
                                        className="fas fa-mountain"
                                        style={{
                                          fontSize: "20px",
                                          color: "var(--sf-night-text, black)",
                                        }}
                                      />
                                      <p style={{ margin: 0, color: "var(--sf-night-text, black)" }}>
                                        {t("Altitude")} (Pa)
                                      </p>
                                      <p style={{ margin: 0, color: "var(--sf-night-text, black)" }}>
                                        {data.altitude}
                                      </p>
                                    </div>
                                    </div>
                                  </React.Fragment>
                                );
                              })}
                            <hr
                              style={{
                                border: "none",
                                height: "1px",
                                backgroundColor: "black",
                                margin: "16px 0",
                              }}
                            />

                            {filteredSensors &&
                              filteredSensors.map((data) => {
                                // mappingMv('Mv1', data.mv1, data.time, data.sensor_id)
                                // mappingMv('Mv2', data.mv2, data.time, data.sensor_id)
                                // mappingMv('Mv3', data.mv3, data.time, data.sensor_id)

                                return (
                                  <table
                                    key={data.sensor_id || data.time}
                                    className="field-soil-readings"
                                    //class="border-none"
                                    style={{
                                      textAlign: "center",
                                      width: "100%",
                                      gap: 15,
                                    }}
                                  >
                                    <thead>
                                      <tr>
                                        <th>
                                          <i className="fas fa-ruler-vertical" />
                                          <br />
                                          {t("depth_field")}
                                        </th>
                                        <th>
                                          <i className="fas fa-tint" />{" "}
                                          <br />
                                          {t("Humidity")}
                                        </th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      <tr>
                                        <td>{depth.mv1} cm</td>
                                        <td>{mappingMv1} %</td>
                                      </tr>
                                      <tr>
                                        <td>{depth.mv2} cm</td>
                                        <td>{mappingMv2} %</td>
                                      </tr>
                                      <tr>
                                        <td>{depth.mv3} cm</td>
                                        <td>{mappingMv3} %</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                );
                              })}
                          </div>
                          {filteredSensors.map((data) => {
                            return (
                              <h6
                                className="field-sensor-last-reading font-weight-bold"
                                style={{
                                  color: "var(--sf-night-brand, #1d8290)",
                                  fontSize: 14,
                                  textAlign: "center",
                                  marginTop: 6,
                                }}
                              >
                                {t("last_reading")} :{" "}
                                {moment(data.time).locale("fr").format("L, LT")}
                              </h6>
                            );
                          })}
                        </Card.Body>

                        <Card.Footer className="field-sensors-weather border-top">
                          <div>
                            <h6 className="m-0" style={{ fontSize: 14 }}>
                              {t("today_weather")}
                            </h6>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                paddingTop: 10,
                              }}
                            >
                              <div style={{ textAlign: "center" }}>
                                <i
                                  className="fas fa-thermometer-three-quarters"
                                  style={{ fontSize: "20px" }}
                                ></i>
                                <p style={{ margin: 0, fontSize: 14 }}>
                                  {t("Temp.")}
                                </p>
                                <p style={{ margin: 0 }}>
                                  {weatherData.temp}°C
                                </p>
                              </div>
                              <div style={{ textAlign: "center" }}>
                                <i
                                  className="fas fa-cloud-showers-heavy"
                                  style={{ fontSize: "20px" }}
                                ></i>
                                <p style={{ margin: 0, fontSize: 14 }}>
                                  {t("Rain")}
                                </p>
                                <p style={{ margin: 0 }}>
                                  {weatherData.rain ? weatherData.rain : 0} mm
                                </p>
                              </div>
                              <div style={{ textAlign: "center" }}>
                                <img
                                  src={evapo}
                                  alt="evapoIcon"
                                  style={{ width: "20px", height: "20px" }}
                                />
                                <p style={{ margin: 0, fontSize: 14 }}>ET0</p>

                                <p style={{ margin: 0 }}>{et0} mm</p>
                              </div>
                              <div style={{ textAlign: "center" }}>
                                <i className="fas fa-wind" style={{ fontSize: 20 }} />
                                <p style={{ margin: 0, fontSize: 14 }}>
                                  {t(`wind`)}
                                </p>

                                <p style={{ margin: 0 }}>
                                  {weatherData.wind} <br />
                                  km/h
                                </p>
                              </div>
                            </div>
                          </div>
                        </Card.Footer>
                      </>
                    </Card>
                  ) : (
                    <Card
                      className="field-overview-card"
                      fluid
                      style={{
                        minHeight: "414.6px",
                        borderRadius: "12px",
                        boxShadow: "0 4px 12px var(--sf-night-shadow, rgba(0, 0, 0, 0.1))",
                        border: "none",
                      }}
                    >
                      <Card.Header
                        style={{
                          background:
                            "linear-gradient(135deg, var(--sf-night-primary, var(--sf-primary-turquoise, #26a6b7)) 0%, var(--sf-night-primary, var(--sf-medium-turquoise, #e8f7f9)) 100%)",
                          color: "white",
                          borderRadius: "12px 12px 0 0",
                          padding: "15px 20px",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        {t("Weather_Overview")}
                      </Card.Header>
                      <Card.Body style={{ padding: "25px" }}>
                        {weatherData ? (
                          <>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "20px",
                              }}
                            >
                              <div style={{ textAlign: "center", flex: 1 }}>
                                <div
                                  style={{
                                    background: "var(--sf-night-surface-alt, #e8f7f9)",
                                    borderRadius: "50%",
                                    width: "50px",
                                    height: "50px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    margin: "0 auto 10px",
                                  }}
                                >
                                  <i
                                    className="fas fa-thermometer-half"
                                    style={{
                                      fontSize: "22px",
                                      color: "var(--sf-night-brand, #1d8290)",
                                    }}
                                  ></i>
                                </div>
                                <p
                                  style={{
                                    margin: "0 0 5px",
                                    fontSize: "14px",
                                    color: "var(--sf-night-text-secondary, #666)",
                                  }}
                                >
                                  {t("Temp.")}
                                </p>
                                <p
                                  style={{
                                    margin: 0,
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    color: "var(--sf-night-text, #333)",
                                  }}
                                >
                                  {weatherData.temp}°C
                                </p>
                              </div>

                              <div style={{ textAlign: "center", flex: 1 }}>
                                <div
                                  style={{
                                    background: "var(--sf-night-surface-alt, #e8f7f9)",
                                    borderRadius: "50%",
                                    width: "50px",
                                    height: "50px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    margin: "0 auto 10px",
                                  }}
                                >
                                  <i
                                    className="fas fa-cloud-rain"
                                    style={{
                                      fontSize: "22px",
                                      color: "var(--sf-night-brand, #1d8290)",
                                    }}
                                  ></i>
                                </div>
                                <p
                                  style={{
                                    margin: "0 0 5px",
                                    fontSize: "14px",
                                    color: "var(--sf-night-text-secondary, #666)",
                                  }}
                                >
                                  {t("Rain")}
                                </p>
                                <p
                                  style={{
                                    margin: 0,
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    color: "var(--sf-night-text, #333)",
                                  }}
                                >
                                  {weatherData.rain ? weatherData.rain : 0} mm
                                </p>
                              </div>

                              <div style={{ textAlign: "center", flex: 1 }}>
                                <div
                                  style={{
                                    background: "var(--sf-night-surface-alt, #e8f7f9)",
                                    borderRadius: "50%",
                                    width: "50px",
                                    height: "50px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    margin: "0 auto 10px",
                                  }}
                                >
                                  <i
                                    className="fa-solid fa-droplet"
                                    style={{
                                      fontSize: "22px",
                                      color: "var(--sf-night-brand, #1d8290)",
                                    }}
                                  ></i>
                                </div>
                                <p
                                  style={{
                                    margin: "0 0 5px",
                                    fontSize: "14px",
                                    color: "var(--sf-night-text-secondary, #666)",
                                  }}
                                >
                                  ET0
                                </p>
                                <p
                                  style={{
                                    margin: 0,
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    color: "var(--sf-night-text, #333)",
                                  }}
                                >
                                  {et0} mm
                                </p>
                              </div>

                              <div style={{ textAlign: "center", flex: 1 }}>
                                <div
                                  style={{
                                    background: "var(--sf-night-surface-alt, #e8f7f9)",
                                    borderRadius: "50%",
                                    width: "50px",
                                    height: "50px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    margin: "0 auto 10px",
                                  }}
                                >
                                  <i
                                    className="fas fa-wind"
                                    style={{
                                      fontSize: "22px",
                                      color: "var(--sf-night-brand, #1d8290)",
                                    }}
                                  ></i>
                                </div>
                                <p
                                  style={{
                                    margin: "0 0 5px",
                                    fontSize: "14px",
                                    color: "var(--sf-night-text-secondary, #666)",
                                  }}
                                >
                                  {t("wind")}
                                </p>
                                <p
                                  style={{
                                    margin: 0,
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    color: "var(--sf-night-text, #333)",
                                  }}
                                >
                                  {weatherData.wind}
                                  <br />
                                  km/h
                                </p>
                              </div>
                            </div>

                            <div
                              style={{
                                background: "var(--sf-night-surface, #f9fbfb)",
                                borderRadius: "8px",
                                padding: "15px",
                                marginTop: "20px",
                              }}
                            >
                              <h5
                                style={{
                                  textAlign: "center",
                                  color: "var(--sf-night-brand, #1d8290)",
                                  marginBottom: "10px",
                                }}
                              >
                                <i
                                  className="fas fa-mobile-alt"
                                  style={{ marginRight: "8px" }}
                                ></i>
                                {t("Install/Register_Sensor")}
                              </h5>
                              <p
                                style={{
                                  textAlign: "center",
                                  color: "var(--sf-night-text-secondary, #666)",
                                  margin: 0,
                                  fontSize: "14px",
                                }}
                              >
                                {t("Install/Register_Sensor_Desc")}
                              </p>
                            </div>
                          </>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "100%",
                            }}
                          >
                            <i
                              className="fas fa-cloud"
                              style={{
                                fontSize: "50px",
                                color: "var(--sf-night-brand, #1d8290)",
                                marginBottom: "15px",
                              }}
                            ></i>
                            <h5
                              style={{
                                textAlign: "center",
                                color: "var(--sf-night-brand, #1d8290)",
                                marginBottom: "10px",
                              }}
                            >
                              Weather Data Unavailable
                            </h5>
                            <p
                              style={{
                                textAlign: "center",
                                color: "var(--sf-night-text-secondary, #666)",
                                margin: 0,
                              }}
                            >
                              Please check your connection or try again later.
                            </p>
                          </div>
                        )}
                      </Card.Body>
                    </Card>
                  )}
                </Col>
                {
                  <Col lg="4" md="12" sm="12" className="field-overview-column field-soil-column">
                    {/* soil status */}
                    {loadingsoil ? (
                      // 🔄 Loading Spinner
                      <Card
                        key={
                          JSON.stringify(sensors) +
                          JSON.stringify(allDataSensor)
                        }
                        fluid
                        style={{
                          height: "414px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: "12px",
                          boxShadow: "0 4px 12px var(--sf-night-shadow, rgba(0, 0, 0, 0.1))",
                        }}
                      >
                        <div
                          className="spinner-border text-info"
                          role="status"
                          style={{ width: "3rem", height: "3rem" }}
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </Card>
                    ) : sensors.length > 0 && allDataSensor.length > 0 ? (
                        <Card
                          key={sensorCode || Uid}
                          className="field-soil-card"
                        >
                          <Card.Header
                            className="border-bottom d-flex justify-content-between align-items-center flex-wrap"
                          >
                            <span className="field-soil-heading">{t("soil_status")}</span>
                            <Button
                              variant="primary"
                              onClick={() => navigate(`/Graphs/${Uid}`)}
                              className="field-detail-see-all-button"
                            >
                              {t("see_all")}
                              <ArrowUpRight size={16} aria-hidden="true" />
                            </Button>
                          </Card.Header>
                          <Card.Body className="field-soil-body">
                            <SubSoil
                              codeSensor={sensorCode}
                              sensorDepths={depth}
                            />
                            {filteredSensors.map((reading) => (
                              <SoilMoistureLevels
                                key={reading.sensor_id || reading.code}
                                reading={reading}
                                sensorDepths={depth}
                              />
                            ))}
                          </Card.Body>
                        </Card>
                    ) : (
                      <Card
                        key={
                          JSON.stringify(sensors) +
                          JSON.stringify(allDataSensor)
                        }
                        fluid
                        style={{
                          background: "var(--sf-night-surface, white)",
                          borderRadius: "12px",
                          boxShadow: "0 4px 12px var(--sf-night-shadow, rgba(0, 0, 0, 0.1))",
                          border: "none",
                        }}
                      >
                        <Card.Header
                          style={{
                            background:
                              "linear-gradient(135deg, var(--sf-night-primary, var(--sf-primary-turquoise, #26a6b7)) 0%, var(--sf-night-primary, var(--sf-medium-turquoise, #e8f7f9)) 100%)",
                            color: "white",
                            borderRadius: "12px 12px 0 0",
                            padding: "15px 20px",
                            fontSize: "16px",
                            fontWeight: "600",
                          }}
                        >
                          {t("no_sensor_title")}
                        </Card.Header>
                        <Card.Body
                          className="text-center"
                          style={{ height: "357.4px" }}
                        >
                          <div
                            style={{
                              padding: "24px",
                              maxWidth: "440px",
                              margin: "0 auto",
                            }}
                          >
                            <RadioTower
                              size={36}
                              aria-hidden="true"
                              style={{
                                color: "var(--sf-night-brand, var(--sf-primary-turquoise))",
                                marginBottom: "14px",
                              }}
                            />

                            <h5
                              style={{
                                color: "var(--sf-primary-black)",
                                fontWeight: "var(--sf-font-weight-semibold)",
                                marginBottom: "10px",
                                fontSize: "17px",
                                fontFamily: "var(--sf-font-primary)",
                              }}
                            >
                              {t("no_sensor_title")}
                            </h5>

                            <p
                              style={{
                                color: "var(--sf-text-secondary)",
                                fontSize: "14px",
                                lineHeight: "1.5",
                                marginBottom: "24px",
                                fontWeight: "var(--sf-font-weight-regular)",
                                fontFamily: "var(--sf-font-primary)",
                              }}
                            >
                              {t("no_sensor_description")}
                            </p>

                            <Button
                              className="field-install-sensor-button"
                              onClick={() => setShowInstallModal(true)}
                            >
                              <span className="field-install-sensor-icon">
                                <RadioTower size={21} strokeWidth={2.2} />
                              </span>
                              <span className="field-install-sensor-copy">
                                <small>S.sensor</small>
                                <strong>{t("install_sensor")}</strong>
                              </span>
                              <Sparkles
                                className="field-install-sensor-sparkle"
                                size={18}
                              />
                            </Button>
                          </div>
                        </Card.Body>
                      </Card>
                    )}
                    <SensorInstallModal
                      show={showInstallModal}
                      formData={formData}
                      onHide={() => setShowInstallModal(false)}
                    />
                  </Col>
                }
                {recomBasedOnDate()}
              </Row>
              <hr className="mb-4 text-muted" />
              <Row>
                <Row className="g-4">
                  <div className="container-fluid px-3">
                    {/* Evaporation Chart Section */}
                    <Col xs={12} className="mb-4">
                      <Card
                        className="shadow-sm border-0 h-100"
                        style={{ position: "relative" }}
                      >
                        {/* Season Ended Overlay */}
                        {(!hasCalculationData || seasonStatus.seasonEnded) && (
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundColor: "var(--sf-night-surface, rgba(255, 255, 255, 0.9))",
                              backdropFilter: "blur(8px)",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              zIndex: 10,
                              borderRadius: "12px",
                            }}
                          >
                            <div
                              style={{
                                textAlign: "center",
                                padding: "40px 20px",
                                backgroundColor: "var(--sf-night-surface, rgba(255, 255, 255, 0.95))",
                                borderRadius: "16px",
                                boxShadow: "0 8px 32px var(--sf-night-shadow, rgba(0, 0, 0, 0.1))",
                                border: "1px solid var(--sf-night-border, rgba(255, 255, 255, 0.2))",
                                maxWidth: "420px",
                                transition: "transform 0.3s ease",
                              }}
                            >
                              {!hasCalculationData ? (
                                <>
                                  <i
                                    className="fas fa-chart-line"
                                    style={{
                                      fontSize: "48px",
                                      color: "var(--sf-night-brand, #1d8290)",
                                      marginBottom: "20px",
                                    }}
                                  ></i>
                                  <h3
                                    style={{
                                      color: "var(--sf-night-text, #2c3e50)",
                                      marginBottom: "16px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {calculationLoadError
                                      ? t("calculation_load_error", {
                                        defaultValue: "Erreur lors du chargement du calcul",
                                      })
                                      : t("no_calculation_data")}
                                  </h3>
                                  <p
                                    style={{
                                      color: "var(--sf-night-text-secondary, #7f8c8d)",
                                      fontSize: "16px",
                                      lineHeight: "1.5",
                                      marginBottom: "20px",
                                    }}
                                  >
                                    {calculationLoadError
                                      ? t("calculation_load_error_description", {
                                        defaultValue: "Le serveur n'a pas pu charger les données de calcul. Veuillez réessayer dans quelques instants.",
                                      })
                                      : calculationIssues.length > 0
                                      ? calculationIssues.join(" ")
                                      : t("no_calculation_data_description")}
                                  </p>
                                </>
                              ) : (
                                <>
                                  <i
                                    className="fas fa-calendar-times"
                                    style={{
                                      fontSize: "48px",
                                      color: "var(--sf-night-warning, #f39c12)",
                                      marginBottom: "20px",
                                    }}
                                  ></i>
                                  <h3
                                    style={{
                                      color: "var(--sf-night-text, #2c3e50)",
                                      marginBottom: "16px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {t("season_ended")}
                                  </h3>
                                  <p
                                    style={{
                                      color: "var(--sf-night-text-secondary, #7f8c8d)",
                                      fontSize: "16px",
                                      lineHeight: "1.5",
                                      marginBottom: "24px",
                                    }}
                                  >
                                    {t("season_ended_description")}
                                  </p>

                                  {seasonStatus.seasonEndDate && (
                                    <div
                                      style={{
                                        backgroundColor: "var(--sf-night-surface-alt, #ecf0f1)",
                                        padding: "12px 16px",
                                        borderRadius: "8px",
                                        fontSize: "14px",
                                        color: "var(--sf-night-text-secondary, #5a6c7d)",
                                        marginBottom: "24px",
                                      }}
                                    >
                                      <strong>{t("season_end_date")}:</strong>{" "}
                                      {seasonStatus.seasonEndDate.toLocaleDateString()}
                                    </div>
                                  )}

                                  {/* 🚀 Boutons à connecter (visuel seulement) */}
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "12px",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <button
                                      style={{
                                        backgroundColor: "var(--sf-night-success-fill, #27ae60)",
                                        color: "#fff",
                                        padding: "10px 18px",
                                        borderRadius: "8px",
                                        fontWeight: "600",
                                        border: "none",
                                        cursor: "pointer",
                                        boxShadow:
                                          "0 4px 10px var(--sf-night-shadow, rgba(39, 174, 96, 0.3))",
                                        transition: "transform 0.2s",
                                      }}
                                      onClick={handleCreateNew}
                                      onMouseEnter={(e) =>
                                        (e.target.style.transform =
                                          "scale(1.05)")
                                      }
                                      onMouseLeave={(e) =>
                                        (e.target.style.transform = "scale(1)")
                                      }
                                    >
                                      <i
                                        className="fas fa-plus-circle"
                                        style={{ marginRight: "8px" }}
                                      ></i>
                                      {t("create_new_field")}
                                    </button>
                                    <div
                                      style={{
                                        position: "relative",
                                        display: "inline-block",
                                      }}
                                    >
                                      <button
                                        style={{
                                          backgroundColor: "var(--sf-night-warning-fill, #f39c12)",
                                          color: "#fff",
                                          padding: "10px 18px",
                                          borderRadius: "8px",
                                          fontWeight: "600",
                                          border: "none",
                                          cursor: isDuplicating
                                            ? "not-allowed"
                                            : "pointer",
                                          boxShadow:
                                            "0 4px 10px var(--sf-night-shadow, rgba(243, 156, 18, 0.3))",
                                          transition: "transform 0.2s",
                                          opacity: isDuplicating ? 0.7 : 1,
                                        }}
                                        onMouseEnter={(e) => {
                                          if (!isDuplicating)
                                            e.target.style.transform =
                                              "scale(1.05)";
                                        }}
                                        onMouseLeave={(e) =>
                                          (e.target.style.transform =
                                            "scale(1)")
                                        }
                                        onClick={handleDuplicate}
                                        disabled={isDuplicating}
                                      >
                                        {isDuplicating ? (
                                          <>
                                            <i
                                              className="fas fa-spinner fa-spin"
                                              style={{ marginRight: "8px" }}
                                            ></i>
                                            {t("duplicating")}
                                          </>
                                        ) : (
                                          <>
                                            <i
                                              className="fas fa-copy"
                                              style={{ marginRight: "8px" }}
                                            ></i>
                                            {t("duplicate")}
                                          </>
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        )}

                        {/* Chart Header */}
                        <div
                          style={{
                            background:
                              "linear-gradient(135deg, var(--sf-night-primary, var(--sf-light-turquoise, #e8f7f9)) 0%, var(--sf-night-primary, var(--sf-medium-turquoise, #e8f7f9)) 100%)",
                            padding: "2rem",
                            borderBottom:
                              "1px solid var(--sf-border-light, #e8eaed)",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              flexWrap: "wrap",
                              gap: "1rem",
                            }}
                          >
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <div
                                style={{
                                  background:
                                    "var(--sf-night-primary, var(--sf-primary-turquoise, #26a6b7))",
                                  borderRadius: "16px",
                                  width: "64px",
                                  height: "64px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginRight: "1.5rem",
                                }}
                              >
                                <i
                                  className={`${currentChart.icon} text-white fa-lg`}
                                ></i>
                              </div>
                              <div>
                                <h3
                                  style={{
                                    margin: "0 0 0.5rem 0",
                                    color: "var(--sf-night-brand, var(--sf-text-primary, #1a1a1a))",
                                    fontWeight:
                                      "var(--sf-font-weight-bold, 700)",
                                  }}
                                >
                                  {currentChart.title}
                                </h3>
                                {/* Season Status Indicator */}
                                {!seasonStatus.seasonEnded &&
                                  seasonStatus.remainingDays && (
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        color: "var(--sf-night-success, #27ae60)",
                                        fontWeight: "500",
                                      }}
                                    >
                                      <i
                                        className="fas fa-leaf"
                                        style={{ marginRight: "6px" }}
                                      ></i>
                                      {t("days_remaining")}:{" "}
                                      {seasonStatus.remainingDays}
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <Card.Body
                          className="p-0"
                          style={{
                            filter:
                              !hasCalculationData || seasonStatus.seasonEnded
                                ? "blur(4px)"
                                : "none",
                            opacity:
                              !hasCalculationData || seasonStatus.seasonEnded
                                ? 0.5
                                : 1,
                            transition: "all 0.3s ease",
                          }}
                        >
                          <HourlyEvapoChart
                            fieldUid={Uid}
                            fallbackData={chartData}
                          />
                        </Card.Body>
                      </Card>
                    </Col>

                    {/* Water Chart Section */}
                    <Col xs={12} className="mb-4">
                      <Card
                        className="shadow-sm border-0 h-100"
                        style={{ position: "relative" }}
                      >
                        {/* Season Ended Overlay */}
                        {seasonStatus.seasonEnded && (
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundColor: "var(--sf-night-surface, rgba(255, 255, 255, 0.9))",
                              backdropFilter: "blur(8px)",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              zIndex: 10,
                              borderRadius: "12px",
                            }}
                          >
                            <div
                              style={{
                                textAlign: "center",
                                padding: "40px 20px",
                                backgroundColor: "var(--sf-night-surface, rgba(255, 255, 255, 0.95))",
                                borderRadius: "16px",
                                boxShadow: "0 8px 32px var(--sf-night-shadow, rgba(0, 0, 0, 0.1))",
                                border: "1px solid var(--sf-night-border, rgba(255, 255, 255, 0.2))",
                                maxWidth: "400px",
                              }}
                            >
                              {hasCalculationData && (
                                <>
                                  <i
                                    className="fas fa-calendar-times"
                                    style={{
                                      fontSize: "48px",
                                      color: "var(--sf-night-warning, #f39c12)",
                                      marginBottom: "20px",
                                    }}
                                  ></i>
                                  <h3
                                    style={{
                                      color: "var(--sf-night-text, #2c3e50)",
                                      marginBottom: "16px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {t("season_ended")}
                                  </h3>
                                  <p
                                    style={{
                                      color: "var(--sf-night-text-secondary, #7f8c8d)",
                                      fontSize: "16px",
                                      lineHeight: "1.5",
                                      marginBottom: "20px",
                                    }}
                                  >
                                    {t("season_ended_description")}
                                  </p>
                                  {seasonStatus.seasonEndDate && (
                                    <div
                                      style={{
                                        backgroundColor: "var(--sf-night-surface-alt, #ecf0f1)",
                                        padding: "12px 16px",
                                        borderRadius: "8px",
                                        fontSize: "14px",
                                        color: "var(--sf-night-text-secondary, #5a6c7d)",
                                      }}
                                    >
                                      <strong>{t("season_end_date")}:</strong>{" "}
                                      {seasonStatus.seasonEndDate.toLocaleDateString()}
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        )}
                        {hasCalculationData ? (
                          <>
                            {/* Chart Header */}
                            <div
                              style={{
                                background:
                                  "linear-gradient(135deg, var(--sf-night-primary, var(--sf-light-turquoise, #e8f7f9)) 0%, var(--sf-night-primary, var(--sf-medium-turquoise, #e8f7f9)) 100%)",
                                padding: "2rem",
                                borderBottom:
                                  "1px solid var(--sf-border-light, #e8eaed)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  flexWrap: "wrap",
                                  gap: "1rem",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      background:
                                        "var(--sf-night-primary, var(--sf-primary-turquoise, #26a6b7))",
                                      borderRadius: "16px",
                                      width: "64px",
                                      height: "64px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginRight: "1.5rem",
                                    }}
                                  >
                                    <i
                                      className={`${chartConfig.water.icon} text-white fa-lg`}
                                    ></i>
                                  </div>
                                  <div>
                                    <h3
                                      style={{
                                        margin: "0 0 0.5rem 0",
                                        color:
                                          "var(--sf-night-brand, var(--sf-text-primary, #1a1a1a))",
                                        fontWeight:
                                          "var(--sf-font-weight-bold, 700)",
                                      }}
                                    >
                                      {chartConfig.water.title}
                                    </h3>
                                    {/* Season Status Indicator */}
                                    {!seasonStatus.seasonEnded &&
                                      seasonStatus.remainingDays && (
                                        <div
                                          style={{
                                            fontSize: "14px",
                                            color: "var(--sf-night-success, #27ae60)",
                                            fontWeight: "500",
                                          }}
                                        >
                                          <i
                                            className="fas fa-leaf"
                                            style={{ marginRight: "6px" }}
                                          ></i>
                                          {t("days_remaining")}:{" "}
                                          {seasonStatus.remainingDays}
                                        </div>
                                      )}
                                  </div>
                                </div>
                                {sensors.length > 0 && (
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        size="small"
                                        checked={isToggled}
                                        onChange={(e) => {
                                          const newValue = e.target.checked;
                                          setIsToggled(newValue);
                                          handleToggleSensorChart(newValue);
                                        }}
                                        sx={{
                                          "& .MuiSwitch-switchBase.Mui-checked":
                                            {
                                              color: "var(--sf-night-brand, #26a6b7)",
                                            },
                                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                            {
                                              backgroundColor: "var(--sf-night-primary, #26a6b7)",
                                            },
                                        }}
                                      />
                                    }
                                    label={
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          fontSize: "14px",
                                          color: "var(--sf-night-text, #1a1a1a)", // correction : il y avait 2 #
                                        }}
                                      >
                                        {t("prevision_based_on_sensor_data")}
                                      </Typography>
                                    }
                                    labelPlacement="start"
                                  />
                                )}
                              </div>
                            </div>

                            <Card.Body
                              className="pr-5"
                              style={{
                                filter: seasonStatus.seasonEnded
                                  ? "blur(4px)"
                                  : "none",
                                opacity: seasonStatus.seasonEnded ? 0.5 : 1,
                                transition: "all 0.3s ease",
                              }}
                            >
                              <WaterChart data={chartData}
                              isSensorActive={isToggled}  />
                            </Card.Body>
                          </>
                        ) : (
                          <></>
                        )}
                      </Card>
                    </Col>
                  </div>
                </Row>
              </Row>
            </Col>
          </Row>

          <Row className="pb-4">
            <Col lg="12" md="12" sm="12">
              <Card className="field-calendar-card">
                <Card.Body className="field-calendar-body" dir={dir}>
                  <div className="field-calendar-heading">
                    <span className="field-calendar-heading-icon">
                      <i className="far fa-calendar-alt" aria-hidden="true" />
                    </span>
                    <div>
                      <h3>{t("calendar")}</h3>
                      <p>Sans refus, une irrigation prévue est supposée effectuée. Corrigez ou supprimez une irrigation non effectuée pour recalculer les besoins suivants.</p>
                      <p>{getFilteredEvents().length} {t("events")}</p>
                    </div>
                  </div>
                  {/* Enhanced Header with Controls */}
                  {rainfallCalculationPending && (
                    <div className="field-rain-recalculation-notice" role="status">
                      {t("rain_recalculation_pending", "Données de pluie modifiées — recalcul nécessaire. Les recommandations affichées correspondent au dernier calcul.")}
                    </div>
                  )}
                  <div
                    className="field-calendar-controls"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                      marginBottom: "20px",
                      backgroundColor: "var(--sf-night-surface, #f9fbfb)",
                      padding: "15px",
                      borderRadius: "10px",
                    }}
                  >
                    {/* Top Row: View Toggle and Search */}
                    <div
                      className="field-calendar-controls-top"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "15px",
                        flexWrap: "wrap",
                      }}
                    >
                      {/* View Toggle Buttons */}
                      <div
                        className="field-calendar-view-switch"
                        style={{
                          display: "flex",
                          gap: "8px",
                          backgroundColor: "var(--sf-night-surface, white)",
                          padding: "4px",
                          borderRadius: "8px",
                          boxShadow: "0 2px 4px var(--sf-night-shadow, rgba(0,0,0,0.1))",
                        }}
                      >
                        <button
                          className={viewMode === "calendar" ? "is-active" : ""}
                          onClick={() => setViewMode("calendar")}
                          style={{
                            padding: "8px 16px",
                            backgroundColor:
                              viewMode === "calendar"
                                ? "var(--sf-night-primary, #1d8290)"
                                : "transparent",
                            color:
                              viewMode === "calendar" ? "white" : "var(--sf-night-muted, #82909f)",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "500",
                            transition: "all 0.2s ease",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <rect
                              x="3"
                              y="4"
                              width="18"
                              height="18"
                              rx="2"
                              ry="2"
                            ></rect>
                            <line x1="16" y1="2" x2="16" y2="6"></line>
                            <line x1="8" y1="2" x2="8" y2="6"></line>
                            <line x1="3" y1="10" x2="21" y2="10"></line>
                          </svg>
                          {t("calendar_view")}
                        </button>
                        <button
                          className={viewMode === "list" ? "is-active" : ""}
                          onClick={() => setViewMode("list")}
                          style={{
                            padding: "8px 16px",
                            backgroundColor:
                              viewMode === "list" ? "var(--sf-night-primary, #1d8290)" : "transparent",
                            color: viewMode === "list" ? "white" : "var(--sf-night-muted, #82909f)",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "500",
                            transition: "all 0.2s ease",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <line x1="8" y1="6" x2="21" y2="6"></line>
                            <line x1="8" y1="12" x2="21" y2="12"></line>
                            <line x1="8" y1="18" x2="21" y2="18"></line>
                            <line x1="3" y1="6" x2="3.01" y2="6"></line>
                            <line x1="3" y1="12" x2="3.01" y2="12"></line>
                            <line x1="3" y1="18" x2="3.01" y2="18"></line>
                          </svg>
                          {t("list_view")}
                        </button>
                      </div>

                      {/* Search Bar - Only visible in list view */}
                      {viewMode === "list" && (
                        <div
                          className="field-calendar-search"
                          style={{
                            position: "relative",
                            flex: "1",
                            minWidth: "250px",
                            maxWidth: "400px",
                          }}
                        >
                          <svg
                            style={{
                              position: "absolute",
                              left: "12px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              color: "var(--sf-night-muted, #82909f)",
                            }}
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <circle cx="11" cy="11" r="8"></circle>
                            <path d="m21 21-4.35-4.35"></path>
                          </svg>
                          <input
                            type="text"
                            placeholder={t("search_events")}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            style={{
                              width: "100%",
                              padding: "10px 12px 10px 40px",
                              border: "2px solid var(--sf-night-border, #e5ebef)",
                              borderRadius: "8px",
                              fontSize: "14px",
                              outline: "none",
                              transition: "all 0.2s ease",
                            }}
                            onFocus={(e) => {
                              e.target.style.borderColor = "#1d8290";
                              e.target.style.boxShadow =
                                "0 0 0 3px rgba(52, 152, 219, 0.1)";
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = "#e5ebef";
                              e.target.style.boxShadow = "none";
                            }}
                          />
                          {searchQuery && (
                            <button
                              onClick={() => setSearchQuery("")}
                              style={{
                                position: "absolute",
                                right: "8px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                padding: "4px",
                                color: "var(--sf-night-muted, #82909f)",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                              >
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                              </svg>
                            </button>
                          )}
                        </div>
                      )}
                    </div>

                    {/* Date Filter Buttons - Only visible in list view */}
                    {viewMode === "list" && (
                      <div
                        className="field-calendar-date-filters"
                        style={{
                          display: "flex",
                          gap: "8px",
                          flexWrap: "wrap",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "13px",
                            color: "var(--sf-night-muted, #82909f)",
                            fontWeight: "500",
                          }}
                        >
                          {t("filter_by_date")}:
                        </span>
                        {[
                          { value: "all", label: t("all_dates") },
                          { value: "today", label: t("today") },
                          { value: "thisWeek", label: t("this_week") },
                          { value: "thisMonth", label: t("this_month") },
                          { value: "upcoming", label: t("upcoming") },
                          { value: "past", label: t("past") },
                        ].map((filter) => (
                          <button
                            key={filter.value}
                            className={dateFilter === filter.value ? "is-active" : ""}
                            onClick={() => setDateFilter(filter.value)}
                            style={{
                              padding: "6px 14px",
                              backgroundColor:
                                dateFilter === filter.value
                                  ? "var(--sf-night-primary, #1d8290)"
                                  : "var(--sf-night-surface, white)",
                              color:
                                dateFilter === filter.value
                                  ? "white"
                                  : "var(--sf-night-muted, #82909f)",
                              border: "1px solid var(--sf-night-border, #e5ebef)",
                              borderRadius: "6px",
                              cursor: "pointer",
                              fontSize: "13px",
                              fontWeight: "500",
                              transition: "all 0.2s ease",
                              whiteSpace: "nowrap",
                            }}
                            onMouseOver={(e) => {
                              if (dateFilter !== filter.value) {
                                e.target.style.backgroundColor = "#f9fbfb";
                              }
                            }}
                            onMouseOut={(e) => {
                              if (dateFilter !== filter.value) {
                                e.target.style.backgroundColor = "white";
                              }
                            }}
                          >
                            {filter.label}
                          </button>
                        ))}
                      </div>
                    )}

                    {/* Active Filters Summary */}
                    {viewMode === "list" &&
                      (searchQuery || dateFilter !== "all") && (
                        <div
                          className="field-calendar-filter-summary"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            fontSize: "13px",
                            color: "var(--sf-night-text, #23364d)",
                            padding: "8px 12px",
                            backgroundColor: "var(--sf-night-surface, white)",
                            borderRadius: "6px",
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
                          </svg>
                          <span>
                            {t("showing")}{" "}
                            {getFilteredAndSearchedEvents().length}{" "}
                            {t("events")}
                          </span>
                          <button
                            onClick={() => {
                              setSearchQuery("");
                              setDateFilter("all");
                            }}
                            style={{
                              marginLeft: "auto",
                              padding: "4px 10px",
                              backgroundColor: "transparent",
                              color: "var(--sf-night-danger, #b83d53)",
                              border: "1px solid var(--sf-night-danger, #b83d53)",
                              borderRadius: "4px",
                              cursor: "pointer",
                              fontSize: "12px",
                              fontWeight: "500",
                              transition: "all 0.2s ease",
                            }}
                            onMouseOver={(e) => {
                              e.target.style.backgroundColor = "#b83d53";
                              e.target.style.color = "white";
                            }}
                            onMouseOut={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.color = "#b83d53";
                            }}
                          >
                            {t("clear_filters")}
                          </button>
                        </div>
                      )}
                  </div>

                  {/* Calendar View */}
                  {viewMode === "calendar" && (
                    <div className="field-calendar-view" style={{ position: "relative" }}>
                      {calendarLoading && (
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "var(--sf-night-surface, rgba(255, 255, 255, 0.8))",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 1000,
                          }}
                        >
                          <div
                            style={{
                              border: "4px solid var(--sf-night-border, #f3f3f3)",
                              borderTop: "4px solid var(--sf-night-brand, #1d8290)",
                              borderRadius: "50%",
                              width: "40px",
                              height: "40px",
                              animation: "spin 1s linear infinite",
                            }}
                          ></div>
                        </div>
                      )}
                      <Calendar
                        messages={calendarMessages(t)}
                        culture={i18n.language}
                        localizer={localizer}
                        events={getFilteredEvents()}
                        views={["month", "week", "day"]}
                        startAccessor="start"
                        endAccessor="end"
                        style={{ height: "80vh", minHeight: "400px" }}
                        dayLayoutAlgorithm="no-overlap"
                        eventPropGetter={eventStyleGetter}
                        selectable
                        resizable
                        draggable
                        components={{
                          eventWrapper: ({ children }) => (
                            <div
                              style={{ minWidth: 0 }}
                            >
                              {children}
                            </div>
                          ),
                          event: ({ event }) => (
                            <div className="field-calendar-agri-event">
                              <div className="field-calendar-agri-title">
                                <span aria-hidden="true">●</span>
                                {getEventTitle(event, t)}
                              </div>
                              <RainSourceBadge event={event} t={t} />
                              {isWaterEvent(event) ? (
                                <div className="field-calendar-agri-meta">
                                  {event.category_code === "rain" || isRainEvent(event)
                                    ? `${getRainAmountLabel(event, t)}: ${Number(event.dose || 0).toFixed(2)} mm`
                                    : `${t("duration")}: ${getEventDurationLabel(event, t)}`}
                                </div>
                              ) : (
                                <div className="field-calendar-agri-meta">
                                  {t(`agri_status_${event.execution_status || "planned"}`)}
                                  {event.operator_name ? ` · ${event.operator_name}` : ""}
                                </div>
                              )}
                            </div>
                          ),
                        }}
                        onSelectSlot={handleSelectSlot}
                        onSelectEvent={(event, e) => {
                          handleEventSelect(event, event.source);
                        }}
                      />
                    </div>
                  )}

                  {/* List View */}
                  {viewMode === "list" && (
                    <div
                      className="field-calendar-list-view"
                      style={{
                        height: "80vh",
                        minHeight: "400px",
                        overflowY: "auto",
                        padding: "10px",
                      }}
                    >
                      {getFilteredAndSearchedEvents().length === 0 ? (
                        <div
                          style={{
                            textAlign: "center",
                            padding: "60px 20px",
                            color: "var(--sf-night-muted, #82909f)",
                          }}
                        >
                          <svg
                            width="64"
                            height="64"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            style={{ margin: "0 auto 20px", opacity: 0.3 }}
                          >
                            <circle cx="11" cy="11" r="8"></circle>
                            <path d="m21 21-4.35-4.35"></path>
                          </svg>
                          <h5 style={{ marginBottom: "8px" }}>
                            {t("no_events_found")}
                          </h5>
                          <p style={{ fontSize: "14px", color: "var(--sf-night-muted, #adb5bd)" }}>
                            {searchQuery || dateFilter !== "all"
                              ? t("try_different_filters")
                              : t("no_events")}
                          </p>
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                          }}
                        >
                          {getFilteredAndSearchedEvents().map(
                            (event, index) => {
                              const eventColor =
                                eventStyleGetter(event).style.backgroundColor;
                              const isToday =
                                new Date(event.start).toDateString() ===
                                new Date().toDateString();
                              return (
                                <div
                                  key={index}
                                  onClick={() =>
                                    handleEventSelect(event, event.source)
                                  }
                                  style={{
                                    padding: "16px",
                                    backgroundColor: "var(--sf-night-surface, white)",
                                    border: `3px solid ${eventColor}`,
                                    borderRadius: "8px",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease",
                                    boxShadow: isToday
                                      ? "0 4px 12px var(--sf-night-shadow, rgba(52, 152, 219, 0.2))"
                                      : "0 2px 4px var(--sf-night-shadow, rgba(0,0,0,0.1))",
                                    position: "relative",
                                  }}
                                  onMouseOver={(e) => {
                                    e.currentTarget.style.transform =
                                      "translateX(4px)";
                                    e.currentTarget.style.boxShadow =
                                      "0 4px 12px rgba(0,0,0,0.15)";
                                  }}
                                  onMouseOut={(e) => {
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                    e.currentTarget.style.boxShadow = isToday
                                      ? "0 4px 12px rgba(52, 152, 219, 0.2)"
                                      : "0 2px 4px rgba(0,0,0,0.1)";
                                  }}
                                >
                                  {isToday && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "8px",
                                        right: "8px",
                                        backgroundColor: "var(--sf-night-primary, #1d8290)",
                                        color: "white",
                                        padding: "4px 10px",
                                        borderRadius: "12px",
                                        fontSize: "11px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {t("today")}
                                    </div>
                                  )}
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "start",
                                    }}
                                  >
                                    <div style={{ flex: 1 }}>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                          marginBottom: "10px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            width: "14px",
                                            height: "14px",
                                            backgroundColor: eventColor,
                                            borderRadius: "50%",
                                            border: "2px solid var(--sf-night-border, white)",
                                            boxShadow:
                                              "0 1px 3px var(--sf-night-shadow, rgba(0,0,0,0.2))",
                                          }}
                                        ></div>
                                        <h6
                                          style={{
                                            margin: 0,
                                            fontWeight: "600",
                                            color: "var(--sf-night-text, #23364d)",
                                          }}
                                        >
                                          {getEventTitle(event, t)}
                                        </h6>
                                      </div>
                                      <RainSourceBadge event={event} t={t} />

                                      <div
                                        style={{
                                          fontSize: "13px",
                                          color: "var(--sf-night-muted, #82909f)",
                                          marginBottom: "8px",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "6px",
                                        }}
                                      >
                                        <svg
                                          width="14"
                                          height="14"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                        >
                                          <rect
                                            x="3"
                                            y="4"
                                            width="18"
                                            height="18"
                                            rx="2"
                                            ry="2"
                                          ></rect>
                                          <line
                                            x1="16"
                                            y1="2"
                                            x2="16"
                                            y2="6"
                                          ></line>
                                          <line
                                            x1="8"
                                            y1="2"
                                            x2="8"
                                            y2="6"
                                          ></line>
                                          <line
                                            x1="3"
                                            y1="10"
                                            x2="21"
                                            y2="10"
                                          ></line>
                                        </svg>
                                        <strong>{t("date")}:</strong>{" "}
                                        {new Date(
                                          event.start
                                        ).toLocaleDateString(i18n.language, {
                                          weekday: "long",
                                          year: "numeric",
                                          month: "long",
                                          day: "numeric",
                                        })}
                                      </div>

                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "20px",
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        <div
                                          style={{
                                            fontSize: "13px",
                                            color: "var(--sf-night-muted, #82909f)",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                        >
                                          <svg
                                            width="14"
                                            height="14"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                          >
                                            <circle
                                              cx="12"
                                              cy="12"
                                              r="10"
                                            ></circle>
                                            <polyline points="12 6 12 12 16 14"></polyline>
                                          </svg>
                                          <strong>{t("time")}:</strong>{" "}
                                          {new Date(
                                            event.start
                                          ).toLocaleTimeString(i18n.language, {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                          })}
                                        </div>

                                        {isWaterEvent(event) && !isRainEvent(event) && (
                                          <div
                                            style={{
                                              fontSize: "13px",
                                              color: "var(--sf-night-muted, #82909f)",
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "6px",
                                            }}
                                          >
                                            {/* <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <line x1="12" y1="1" x2="12" y2="23"></line>
                                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                              </svg> */}
                                            <strong>{t("duration")}:</strong>{" "}
                                            {getEventDurationLabel(event, t)}
                                          </div>
                                        )}

                                        <div
                                          style={{
                                            fontSize: "13px",
                                            color: "var(--sf-night-muted, #82909f)",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                        >
                                          <svg
                                            width="14"
                                            height="14"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                          >
                                            <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                                            <line
                                              x1="7"
                                              y1="7"
                                              x2="7.01"
                                              y2="7"
                                            ></line>
                                          </svg>
                                          <strong>{isRainEvent(event) ? getRainAmountLabel(event, t) : t("dose")}:</strong>{" "}
                                          {event.dose
                                            ? Number(event.dose).toFixed(2)
                                            : "0.00"} mm
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      )}
                    </div>
                  )}

                  {/* Enhanced Interactive Legend */}
                  <div
                    style={{
                      marginTop: "20px",
                      padding: "20px",
                      backgroundColor: "var(--sf-night-surface, #f9fbfb)",
                      borderRadius: "12px",
                      border: "1px solid var(--sf-night-border, #e5ebef)",
                    }}
                  >
                    <h6
                      style={{
                        marginBottom: "15px",
                        color: "var(--sf-night-text, #23364d)",
                        fontWeight: "600",
                        textAlign: "center",
                      }}
                    >
                      {t("event_types")}
                    </h6>

                    {!showAgriculturalEventTypes ? (
                      <button
                        type="button"
                        className="field-event-types-launcher"
                        aria-expanded="false"
                        aria-controls="agricultural-event-types-panel"
                        onClick={() => setShowAgriculturalEventTypes(true)}
                      >
                        <span className="field-event-types-launcher__icon" aria-hidden="true">
                          <i className="fas fa-tractor" />
                        </span>
                        <span className="field-event-types-launcher__content">
                          <strong>{t("agri_operations_group")}</strong>
                          <small>{t("agri_operations_group_help")}</small>
                        </span>
                        <span className="field-event-types-launcher__count">
                          {t("agri_event_types_count", { count: AGRICULTURAL_EVENT_CATEGORIES.length - 1 })}
                        </span>
                        <i className="fas fa-chevron-right field-event-types-launcher__arrow" aria-hidden="true" />
                      </button>
                    ) : (
                      <div
                        id="agricultural-event-types-panel"
                        className="field-event-types-panel"
                      >
                        <div className="field-event-types-panel__header">
                          <div>
                            <strong>{t("agri_operations_group")}</strong>
                            <small>{t("agri_event_types_filter_help")}</small>
                          </div>
                          <button
                            type="button"
                            className="field-event-types-close"
                            aria-label={t("agri_event_types_close")}
                            onClick={() => setShowAgriculturalEventTypes(false)}
                          >
                            <i className="fas fa-times" aria-hidden="true" />
                            <span>{t("agri_event_types_close")}</span>
                          </button>
                        </div>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "12px",
                        justifyContent: "center",
                      }}
                    >
                      {AGRICULTURAL_EVENT_CATEGORIES
                        .filter((category) => category.code !== "rain")
                        .map((category) => {
                        const enabled = categoryFilters[category.code];
                        return (
                          <button
                            type="button"
                            key={category.code}
                            onClick={() => toggleCategoryFilter(category.code)}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "7px",
                              padding: "7px 12px",
                              borderRadius: "20px",
                              border: `1px solid ${enabled ? category.color : "#dce4e1"}`,
                              color: enabled ? "white" : "var(--sf-night-muted, #82909f)",
                              backgroundColor: enabled ? category.color : "var(--sf-night-surface-alt, #f1f3f2)",
                              opacity: enabled ? 1 : 0.62,
                              fontSize: "12px",
                              fontWeight: "600",
                            }}
                          >
                            <span
                              aria-hidden="true"
                              style={{ width: 8, height: 8, borderRadius: "50%", background: enabled ? "var(--sf-night-surface, white)" : category.color }}
                            />
                            {t(category.labelKey)}
                          </button>
                        );
                        })}
                    </div>
                    </div>
                    )}
                    <div
                      className="field-event-status-filters"
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "12px",
                        justifyContent: "center",
                        marginTop: "18px",
                      }}
                    >
                      {/* Rain Filter */}
                      <div
                        onClick={() => toggleEventFilter("rain")}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          padding: "8px 16px",
                          backgroundColor: eventFilters.rain
                            ? "var(--sf-night-primary, #87CEEB)"
                            : "var(--sf-night-inset, #e5ebef)",
                          color: eventFilters.rain ? "white" : "var(--sf-night-muted, #82909f)",
                          borderRadius: "20px",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          border: eventFilters.rain
                            ? "2px solid var(--sf-night-border, #87CEEB)"
                            : "2px solid transparent",
                          opacity: eventFilters.rain ? 1 : 0.6,
                          transform: eventFilters.rain
                            ? "scale(1)"
                            : "scale(0.95)",
                        }}
                      >
                        <div
                          style={{
                            width: "12px",
                            height: "12px",
                            backgroundColor: "var(--sf-night-primary, #87CEEB)",
                            borderRadius: "50%",
                            border: "2px solid var(--sf-night-border, white)",
                            boxShadow: "0 1px 3px var(--sf-night-shadow, rgba(0,0,0,0.2))",
                          }}
                        ></div>
                        <span style={{ fontSize: "14px", fontWeight: "500" }}>
                          {t("rain")}
                        </span>
                      </div>

                      {/* Manual Event Filter */}
                      <div
                        onClick={() => toggleEventFilter("manual")}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          padding: "8px 16px",
                          backgroundColor: eventFilters.manual
                            ? "orange"
                            : "var(--sf-night-inset, #e5ebef)",
                          color: eventFilters.manual ? "white" : "var(--sf-night-muted, #82909f)",
                          borderRadius: "20px",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          border: eventFilters.manual
                            ? "2px solid orange"
                            : "2px solid transparent",
                          opacity: eventFilters.manual ? 1 : 0.6,
                          transform: eventFilters.manual
                            ? "scale(1)"
                            : "scale(0.95)",
                        }}
                      >
                        <div
                          style={{
                            width: "12px",
                            height: "12px",
                            backgroundColor: "orange",
                            borderRadius: "50%",
                            border: "2px solid var(--sf-night-border, white)",
                            boxShadow: "0 1px 3px var(--sf-night-shadow, rgba(0,0,0,0.2))",
                          }}
                        ></div>
                        <span style={{ fontSize: "14px", fontWeight: "500" }}>
                          {t("manual_event")}
                        </span>
                      </div>

                      {/* Refused Filter */}
                      <div
                        onClick={() => toggleEventFilter("refused")}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          padding: "8px 16px",
                          backgroundColor: eventFilters.refused
                            ? "red"
                            : "var(--sf-night-inset, #e5ebef)",
                          color: eventFilters.refused ? "white" : "var(--sf-night-muted, #82909f)",
                          borderRadius: "20px",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          border: eventFilters.refused
                            ? "2px solid red"
                            : "2px solid transparent",
                          opacity: eventFilters.refused ? 1 : 0.6,
                          transform: eventFilters.refused
                            ? "scale(1)"
                            : "scale(0.95)",
                        }}
                      >
                        <div
                          style={{
                            width: "12px",
                            height: "12px",
                            backgroundColor: "red",
                            borderRadius: "50%",
                            border: "2px solid var(--sf-night-border, white)",
                            boxShadow: "0 1px 3px var(--sf-night-shadow, rgba(0,0,0,0.2))",
                          }}
                        ></div>
                        <span style={{ fontSize: "14px", fontWeight: "500" }}>
                          {t("refused")}
                        </span>
                      </div>

                      {/* Validated Filter */}
                      <div
                        onClick={() => toggleEventFilter("validated")}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          padding: "8px 16px",
                          backgroundColor: eventFilters.validated
                            ? "green"
                            : "var(--sf-night-inset, #e5ebef)",
                          color: eventFilters.validated ? "white" : "var(--sf-night-muted, #82909f)",
                          borderRadius: "20px",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          border: eventFilters.validated
                            ? "2px solid green"
                            : "2px solid transparent",
                          opacity: eventFilters.validated ? 1 : 0.6,
                          transform: eventFilters.validated
                            ? "scale(1)"
                            : "scale(0.95)",
                        }}
                      >
                        <div
                          style={{
                            width: "12px",
                            height: "12px",
                            backgroundColor: "green",
                            borderRadius: "50%",
                            border: "2px solid var(--sf-night-border, white)",
                            boxShadow: "0 1px 3px var(--sf-night-shadow, rgba(0,0,0,0.2))",
                          }}
                        ></div>
                        <span style={{ fontSize: "14px", fontWeight: "500" }}>
                          {t("validated")}
                        </span>
                      </div>

                      {/* Waiting Filter */}
                      <div
                        onClick={() => toggleEventFilter("waiting")}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          padding: "8px 16px",
                          backgroundColor: eventFilters.waiting
                            ? "#191970"
                            : "var(--sf-night-inset, #e5ebef)",
                          color: eventFilters.waiting ? "white" : "var(--sf-night-muted, #82909f)",
                          borderRadius: "20px",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          border: eventFilters.waiting
                            ? "2px solid var(--sf-night-info, #191970)"
                            : "2px solid transparent",
                          opacity: eventFilters.waiting ? 1 : 0.6,
                          transform: eventFilters.waiting
                            ? "scale(1)"
                            : "scale(0.95)",
                        }}
                      >
                        <div
                          style={{
                            width: "12px",
                            height: "12px",
                            backgroundColor: "#191970",
                            borderRadius: "50%",
                            border: "2px solid var(--sf-night-border, white)",
                            boxShadow: "0 1px 3px var(--sf-night-shadow, rgba(0,0,0,0.2))",
                          }} // Replace your third Row of Posts section with this:
                        ></div>
                        <span style={{ fontSize: "14px", fontWeight: "500" }}>
                          {t("waiting")}
                        </span>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Modal size="lg" show={show} onHide={handleCloseModal}>
            <Modal.Header>
              <Modal.Title>{t("event_details")}</Modal.Title>
            </Modal.Header>

            {selectedEvent && (
              <Modal.Body>
                <div className="border-bottom p-2">
                  <h4
                    style={{
                      fontWeight: "bold",
                      textAlign: "center",
                      margin: 8,
                    }}
                  >
                    {isRainEvent(selectedEvent)
                      ? t("rain")
                      : t("irrigationSummary")}
                  </h4>

                  {/* NEW: Type + Dose + Durée */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: "10px",
                      flexWrap: "wrap",
                      marginBottom: "12px",
                    }}
                  >
                    <span
                      style={{
                        backgroundColor: eventSource === "manual" ? "var(--sf-night-warning-soft, #fff3cd)" : "var(--sf-night-brand-soft, #d1ecf1)",
                        color: eventSource === "manual" ? "var(--sf-night-warning, #856404)" : "var(--sf-night-brand, #0c5460)",
                        padding: "4px 12px",
                        borderRadius: "16px",
                        fontSize: "13px",
                        fontWeight: "600",
                      }}
                    >
                      {isRainEvent(selectedEvent)
                        ? t("rain")
                        : eventSource === "manual"
                        ? <><Hand size={13} aria-hidden="true" /> {t("manual_event")}</>
                          : ` ${t("irrigation_recommendation")}`}
                    </span>
                    <span
                      style={{
                        backgroundColor: "var(--sf-night-surface-alt, #e8f4f8)",
                        color: "var(--sf-night-brand, #2c7a9e)",
                        padding: "4px 12px",
                        borderRadius: "16px",
                        fontSize: "13px",
                        fontWeight: "600",
                      }}
                    >
                      <Droplet size={13} aria-hidden="true" /> {t("dose")}:{" "}
                      {selectedEvent.dose ? parseFloat(selectedEvent.dose).toFixed(2) : "0.00"} mm
                    </span>
                    <span
                      style={{
                        display: isRainEvent(selectedEvent) ? "none" : "inline",
                        backgroundColor: "var(--sf-night-surface-alt, #e8f4f8)",
                        color: "var(--sf-night-brand, #2c7a9e)",
                        padding: "4px 12px",
                        borderRadius: "16px",
                        fontSize: "13px",
                        fontWeight: "600",
                      }}
                    >
                      <Clock size={13} aria-hidden="true" /> {t("duration")}:{" "}
                       {getEventDurationLabel(selectedEvent, t)}
                    </span>
                  </div>

                  <div
                    style={{
                      border: "1px solid var(--sf-night-border, #eee)",
                      borderRadius: "8px",
                      padding: 10,
                    }}
                  >
                    {eventSource === "manual" ? (
                      <>
                        <Row className="g-3 mt-3 justify-content-center">
                          <Col xs={12} sm={6} md={5}>
                            <Form.Group
                              controlId="formDose"
                              className="d-flex flex-column"
                            >
                              <Form.Label className="fw-semibold mb-1">
                                {t("dose_mm")} (mm)
                              </Form.Label>
                              <Form.Control
                                type="number"
                                value={modifiedDose}
                                onChange={(e) =>
                                  setModifiedDose(e.target.value)
                                }
                                className="shadow-sm border rounded"
                                style={{ padding: "8px 10px" }}
                                placeholder={t("enter_dose")}
                              />
                            </Form.Group>
                          </Col>

                          <Col xs={12} sm={6} md={5}>
                            <Form.Group
                              controlId="formTime"
                              className="d-flex flex-column"
                            >
                              <Form.Label className="fw-semibold mb-1">
                                {t("time_mn")}
                              </Form.Label>
                              <Form.Control
                                type="number"
                                value={modifiedTime}
                                onChange={(e) =>
                                  setModifiedTime(e.target.value)
                                }
                                className="shadow-sm border rounded"
                                style={{ padding: "8px 10px" }}
                                placeholder={t("enter_duration")}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </>
                    ) : eventSource === "recommendation" ? (
                      <>
                        {/* <h6
                          style={{
                            fontWeight: "500",
                            textAlign: "center",
                            margin: 4,
                          }}
                        >
                          {t(selectedEvent.title)}
                        </h6> */}

                        <Form.Group controlId="formStatus">
                          <Form.Label>{t("status")}</Form.Label>
                          <div className="d-flex justify-content-center gap-2 mt-2">
                            <Button
                              variant={
                                eventStatus === "validated"
                                  ? "success"
                                  : "outline-success"
                              }
                              onClick={() => {
                                swal({
                                  title: t("Are you sure?"),
                                  text: t("confirm_change_status"),
                                  icon: "warning",
                                  buttons: [t("Cancel"), t("Yes, change it!")],
                                  dangerMode: true,
                                }).then((willChange) => {
                                  if (willChange) {
                                    setEventStatus("validated");
                                  }
                                });
                              }}
                              disabled={
                                selectedEvent.status === "validated" ||
                                selectedEvent.status === "refused"
                              }
                            >
                              {t("validated")}
                            </Button>

                            <Button
                              variant={
                                eventStatus === "waiting"
                                  ? "warning"
                                  : "outline-warning"
                              }
                              onClick={() => {
                                swal({
                                  title: t("Are you sure?"),
                                  text: t("set_status_waiting_confirm"),
                                  icon: "warning",
                                  buttons: [t("Cancel"), t("Yes, change it!")],
                                  dangerMode: true,
                                }).then((willChange) => {
                                  if (willChange) {
                                    setEventStatus("waiting");
                                  }
                                });
                              }}
                              disabled={
                                selectedEvent.status === "validated" ||
                                selectedEvent.status === "refused"
                              }
                            >
                              {t("waiting")}
                            </Button>

                            <Button
                              variant={
                                eventStatus === "refused"
                                  ? "danger"
                                  : "outline-danger"
                              }
                              onClick={() => {
                                swal({
                                  title: t("Are you sure?"),
                                  text: t("set_status_refused_confirm"),
                                  icon: "warning",
                                  buttons: [t("Cancel"), t("Yes, change it!")],
                                  dangerMode: true,
                                }).then((willChange) => {
                                  if (willChange) {
                                    setEventStatus("refused");
                                  }
                                });
                              }}
                              disabled={
                                selectedEvent.status === "validated" ||
                                selectedEvent.status === "refused"
                              }
                            >
                              {t("refused")}
                            </Button>

                            {selectedEvent.status === "refused" && (
                              <Button
                                variant="outline-secondary"
                                onClick={() => {
                                  swal({
                                    title: t("Are you sure?"),
                                    text: t("cancel_refusal_confirm"),
                                    icon: "warning",
                                    buttons: [t("Cancel"), t("Yes, change it!")],
                                    dangerMode: true,
                                  }).then((willChange) => {
                                    if (willChange) {
                                      setEventStatus("waiting");
                                      handleStatusUpdate(selectedEvent.id, "waiting");
                                    }
                                  });
                                }}
                              >
                                {t("cancel_refusal")}
                              </Button>
                            )}
                          </div>
                        </Form.Group>
                      </>
                    ) : null}

                    <Row className="g-3 mt-3 justify-content-center">
                      <Col xs={12} sm={6} md={5}>
                        <Form.Group
                          controlId="start"
                          className="d-flex flex-column"
                        >
                          <Form.Label className="fw-semibold mb-1">
                            {t("start_date")}
                          </Form.Label>
                          <Form.Control
                            disabled
                            type="date"
                            value={modifiedStart || ""}
                            onChange={(e) => setModifiedStart(e.target.value)}
                            className="shadow-sm border rounded"
                            style={{ padding: "8px 10px" }}
                          />
                        </Form.Group>
                      </Col>

                      <Col xs={12} sm={6} md={5}>
                        <Form.Group
                          controlId="end"
                          className="d-flex flex-column"
                        >
                          <Form.Label className="fw-semibold mb-1">
                            {t("end_date")}
                          </Form.Label>
                          <Form.Control
                            disabled
                            type="date"
                            value={modifiedEnd || ""}
                            onChange={(e) => setModifiedEnd(e.target.value)}
                            className="shadow-sm border rounded"
                            style={{ padding: "8px 10px" }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    {eventSource === "recommendation" && (
                      <div className="py-4">
                        <i className="material-icons">&#xe88e;</i>{" "}
                        <span>{t("irrigationCalculationDescription")}</span>
                      </div>
                    )}
                  </div>
                </div>
              </Modal.Body>
            )}

            <Modal.Footer>
              {eventSource === "manual" ? (
                <>
                  <Button
                    variant="primary"
                    onClick={() =>
                      handleModalUpdate({
                        dose: modifiedDose,
                        time: modifiedTime,
                        start: new Date(modifiedStart),
                        end: new Date(modifiedEnd),
                      })
                    }
                  >
                    {t("update")}
                  </Button>
                  <Button
                    variant="danger"
                    onClick={() => handleEventDelete(selectedEvent.id)}
                  >
                    {t("delete")}
                  </Button>
                </>
              ) : eventSource === "recommendation" ? (
                <Button
                  variant="primary"
                  onClick={() =>
                    handleStatusUpdate(selectedEvent.id, eventStatus)
                  }
                >
                  {t("update_status")}
                </Button>
              ) : null}
              <Button variant="secondary" onClick={handleCloseModal}>
                {t("close")}
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Modal for adding irrigation or rain event */}
          <Modal size="md" show={false} onHide={handleNewIrrigCloseModal}>
            <Modal.Header className="d-flex flex-column border-0 pb-0">
              <Modal.Title className="fw-bold">
                {t("add_manual_event")}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-4">
              {/* Event Type Selection - Two Clickable Boxes */}
              <div className="row g-3 mb-4">
                <div className="col-6">
                  <div
                    className={`card h-100 shadow-sm transition ${
                      eventType === "irrigation"
                        ? "border-primary border-2 shadow"
                        : "border border-1"
                    }`}
                    style={{
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      transform:
                        eventType === "irrigation" ? "scale(1.02)" : "scale(1)",
                    }}
                    onClick={() => setEventType("irrigation")}
                  >
                    <div
                      className={`card-body text-center p-4 position-relative`}
                    >
                      {eventType === "irrigation" && (
                        <div
                          className="position-absolute top-0 end-0 m-2"
                          style={{ color: "var(--sf-night-info, #0d6efd)" }}
                        >
                          <i className="bi bi-check-circle-fill fs-5"></i>
                        </div>
                      )}
                      <div
                        className={`rounded-circle d-inline-flex align-items-center justify-content-center mb-3`}
                        style={{
                          width: "70px",
                          height: "70px",
                          backgroundColor:
                            eventType === "irrigation" ? "var(--sf-night-info-soft, #cfe2ff)" : "var(--sf-night-surface, #f9fbfb)",
                        }}
                      >
                        <i
                          className="bi bi-droplet-fill"
                          style={{
                            fontSize: "2rem",
                            color:
                              eventType === "irrigation"
                                ? "var(--sf-night-info, #0d6efd)"
                                : "var(--sf-night-muted, #82909f)",
                          }}
                        ></i>
                      </div>
                      <h6
                        className={`mb-0 ${
                          eventType === "irrigation"
                            ? "text-primary fw-semibold"
                            : "text-secondary"
                        }`}
                      >
                        {t("irrigation_event")}
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="col-6">
                  <div
                    className={`card h-100 shadow-sm ${
                      eventType === "rain"
                        ? "border-info border-2 shadow"
                        : "border border-1"
                    }`}
                    style={{
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      transform:
                        eventType === "rain" ? "scale(1.02)" : "scale(1)",
                    }}
                    onClick={() => setEventType("rain")}
                  >
                    <div
                      className={`card-body text-center p-4 position-relative`}
                    >
                      {eventType === "rain" && (
                        <div
                          className="position-absolute top-0 end-0 m-2"
                          style={{ color: "var(--sf-night-brand, #0dcaf0)" }}
                        >
                          <i className="bi bi-check-circle-fill fs-5"></i>
                        </div>
                      )}
                      <div
                        className={`rounded-circle d-inline-flex align-items-center justify-content-center mb-3`}
                        style={{
                          width: "70px",
                          height: "70px",
                          backgroundColor:
                            eventType === "rain" ? "var(--sf-night-brand-soft, #cff4fc)" : "var(--sf-night-surface, #f9fbfb)",
                        }}
                      >
                        <i
                          className="bi bi-cloud-rain-fill"
                          style={{
                            fontSize: "2rem",
                            color: eventType === "rain" ? "var(--sf-night-brand, #0dcaf0)" : "var(--sf-night-muted, #82909f)",
                          }}
                        ></i>
                      </div>
                      <h6
                        className={`mb-0 ${
                          eventType === "rain"
                            ? "text-info fw-semibold"
                            : "text-secondary"
                        }`}
                      >
                        {t("rain_event")}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>

              {/* Conditional Fields Based on Event Type */}
              {eventType && (
                <div className="animate-fade-in">
                  {eventType === "irrigation" ? (
                    <div className="bg-light rounded p-3 mb-3">
                      {/* <div className="mb-3">
              <label htmlFor="dose" className="form-label fw-semibold small text-muted">
                {t("irrigation_dose_mm")}
              </label>
              <Form.Control
                id="dose"
                placeholder={t("irrigation_dose")}
                type="number"
                value={dose}
                onChange={(e) => setDose(e.target.value)}
                className="border-2"
              />
            </div>
             */}
                      <div className="mb-0">
                        <label
                          htmlFor="time"
                          className="form-label fw-semibold small text-muted"
                        >
                          {t("irrigation_duration_mn")}
                        </label>
                        <Form.Control
                          type="number"
                          id="time"
                          placeholder={t("irrigation_duration")}
                          value={time}
                          onChange={(e) => setTime(e.target.value)}
                          className="border-2"
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="bg-light rounded p-3 mb-3">
                      <div className="mb-3">
                        <label
                          htmlFor="rainfall"
                          className="form-label fw-semibold small text-muted"
                        >
                          {t("rainfall_amount_mm")}
                        </label>
                        <Form.Control
                          id="rainfall"
                          placeholder={t("rainfall_amount")}
                          type="number"
                          value={rainfallAmount}
                          onChange={(e) => setRainfallAmount(e.target.value)}
                          className="border-2"
                        />
                      </div>

                      {/* <div className="mb-0">
              <label htmlFor="rain-duration" className="form-label fw-semibold small text-muted">
                {t("rain_duration_hours")}
              </label>
              <Form.Control
                type="number"
                id="rain-duration"
                placeholder={t("rain_duration")}
                value={rainDuration}
                onChange={(e) => setRainDuration(e.target.value)}
                className="border-2"
              />
            </div> */}
                    </div>
                  )}

                  {/* Common Date Fields */}
                  <div className="row g-3">
                    <div className="col-6">
                      <label className="form-label fw-semibold small text-muted">
                        {t("start_date")}
                      </label>
                      <Form.Control
                        disabled
                        type="date"
                        value={manualStartDate}
                        onChange={(e) => setManualStartDate(e.target.value)}
                        className="border-2"
                      />
                    </div>

                    <div className="col-6">
                      <label className="form-label fw-semibold small text-muted">
                        {t("end_date")}
                      </label>
                      <Form.Control
                        disabled
                        type="date"
                        value={manualEndDate}
                        onChange={(e) => setManualEndDate(e.target.value)}
                        className="border-2"
                      />
                    </div>
                  </div>
                </div>
              )}

              {!eventType && (
                <div className="text-center text-muted py-4">
                  <i className="bi bi-hand-index fs-1 mb-2 d-block"></i>
                  <p className="mb-0">{t("please_select_event_type")}</p>
                </div>
              )}
            </Modal.Body>

            <Modal.Footer className="border-0 pt-0">
              <Button
                variant="outline-secondary"
                onClick={handleNewIrrigCloseModal}
              >
                {t("cancel")}
              </Button>
              <Button
                variant={eventType === "irrigation" ? "primary" : "info"}
                onClick={
                  eventType === "irrigation" ? handleSaveEvent : handleSaveRain
                }
                disabled={!eventType}
                className="px-4"
              >
                <i className="bi bi-check-lg me-2"></i>
                {t("save")}
              </Button>
            </Modal.Footer>
          </Modal>

          <AgriculturalEventDrawer
            show={showForNew}
            onHide={handleNewIrrigCloseModal}
            fieldUid={Uid}
            initialStart={manualStartDate}
            initialEnd={manualEndDate}
            initialEvent={editingAgriculturalEvent}
            t={t}
            dir={dir}
            onSaved={async (_event, categoryCode) => {
              await getEvents();
              if (categoryCode === "irrigation" || categoryCode === "rain") {
                fetchDataCalcul();
              }
            }}
            onDeleted={async (_eventId, categoryCode) => {
              await getEvents();
              if (categoryCode === "irrigation" || categoryCode === "rain") {
                fetchDataCalcul();
              }
            }}
          />

          <style jsx>{`
            .animate-fade-in {
              animation: fadeIn 0.3s ease-in;
            }

            @keyframes fadeIn {
              from {
                opacity: 0;
                transform: translateY(-10px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }
          `}</style>
        </Container>
      )}
    </>
  );
};
export default Field;
